const replaceChar = (char) => {
  switch (char) {
    case '\u{00C0}': // À  [LATIN CAPITAL LETTER A WITH GRAVE]
    case '\u{00C1}': // Á  [LATIN CAPITAL LETTER A WITH ACUTE]
    case '\u{00C2}': // Â  [LATIN CAPITAL LETTER A WITH CIRCUMFLEX]
    case '\u{00C3}': // Ã  [LATIN CAPITAL LETTER A WITH TILDE]
    case '\u{00C4}': // Ä  [LATIN CAPITAL LETTER A WITH DIAERESIS]
    case '\u{00C5}': // Å  [LATIN CAPITAL LETTER A WITH RING ABOVE]
    case '\u{0100}': // Ā  [LATIN CAPITAL LETTER A WITH MACRON]
    case '\u{0102}': // Ă  [LATIN CAPITAL LETTER A WITH BREVE]
    case '\u{0104}': // Ą  [LATIN CAPITAL LETTER A WITH OGONEK]
    case '\u{018F}': // Ə  http://en.wikipedia.org/wiki/Schwa  [LATIN CAPITAL LETTER SCHWA]
    case '\u{01CD}': // Ǎ  [LATIN CAPITAL LETTER A WITH CARON]
    case '\u{01DE}': // Ǟ  [LATIN CAPITAL LETTER A WITH DIAERESIS AND MACRON]
    case '\u{01E0}': // Ǡ  [LATIN CAPITAL LETTER A WITH DOT ABOVE AND MACRON]
    case '\u{01FA}': // Ǻ  [LATIN CAPITAL LETTER A WITH RING ABOVE AND ACUTE]
    case '\u{0200}': // Ȁ  [LATIN CAPITAL LETTER A WITH DOUBLE GRAVE]
    case '\u{0202}': // Ȃ  [LATIN CAPITAL LETTER A WITH INVERTED BREVE]
    case '\u{0226}': // Ȧ  [LATIN CAPITAL LETTER A WITH DOT ABOVE]
    case '\u{023A}': // Ⱥ  [LATIN CAPITAL LETTER A WITH STROKE]
    case '\u{1D00}': // ᴀ  [LATIN LETTER SMALL CAPITAL A]
    case '\u{1E00}': // Ḁ  [LATIN CAPITAL LETTER A WITH RING BELOW]
    case '\u{1EA0}': // Ạ  [LATIN CAPITAL LETTER A WITH DOT BELOW]
    case '\u{1EA2}': // Ả  [LATIN CAPITAL LETTER A WITH HOOK ABOVE]
    case '\u{1EA4}': // Ấ  [LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND ACUTE]
    case '\u{1EA6}': // Ầ  [LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND GRAVE]
    case '\u{1EA8}': // Ẩ  [LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE]
    case '\u{1EAA}': // Ẫ  [LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND TILDE]
    case '\u{1EAC}': // Ậ  [LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND DOT BELOW]
    case '\u{1EAE}': // Ắ  [LATIN CAPITAL LETTER A WITH BREVE AND ACUTE]
    case '\u{1EB0}': // Ằ  [LATIN CAPITAL LETTER A WITH BREVE AND GRAVE]
    case '\u{1EB2}': // Ẳ  [LATIN CAPITAL LETTER A WITH BREVE AND HOOK ABOVE]
    case '\u{1EB4}': // Ẵ  [LATIN CAPITAL LETTER A WITH BREVE AND TILDE]
    case '\u{1EB6}': // Ặ  [LATIN CAPITAL LETTER A WITH BREVE AND DOT BELOW]
    case '\u{24B6}': // Ⓐ  [CIRCLED LATIN CAPITAL LETTER A]
    case '\u{FF21}': // Ａ  [FULLWIDTH LATIN CAPITAL LETTER A]
      return 'A'
    case '\u{00E0}': // à  [LATIN SMALL LETTER A WITH GRAVE]
    case '\u{00E1}': // á  [LATIN SMALL LETTER A WITH ACUTE]
    case '\u{00E2}': // â  [LATIN SMALL LETTER A WITH CIRCUMFLEX]
    case '\u{00E3}': // ã  [LATIN SMALL LETTER A WITH TILDE]
    case '\u{00E4}': // ä  [LATIN SMALL LETTER A WITH DIAERESIS]
    case '\u{00E5}': // å  [LATIN SMALL LETTER A WITH RING ABOVE]
    case '\u{0101}': // ā  [LATIN SMALL LETTER A WITH MACRON]
    case '\u{0103}': // ă  [LATIN SMALL LETTER A WITH BREVE]
    case '\u{0105}': // ą  [LATIN SMALL LETTER A WITH OGONEK]
    case '\u{01CE}': // ǎ  [LATIN SMALL LETTER A WITH CARON]
    case '\u{01DF}': // ǟ  [LATIN SMALL LETTER A WITH DIAERESIS AND MACRON]
    case '\u{01E1}': // ǡ  [LATIN SMALL LETTER A WITH DOT ABOVE AND MACRON]
    case '\u{01FB}': // ǻ  [LATIN SMALL LETTER A WITH RING ABOVE AND ACUTE]
    case '\u{0201}': // ȁ  [LATIN SMALL LETTER A WITH DOUBLE GRAVE]
    case '\u{0203}': // ȃ  [LATIN SMALL LETTER A WITH INVERTED BREVE]
    case '\u{0227}': // ȧ  [LATIN SMALL LETTER A WITH DOT ABOVE]
    case '\u{0250}': // ɐ  [LATIN SMALL LETTER TURNED A]
    case '\u{0259}': // ə  [LATIN SMALL LETTER SCHWA]
    case '\u{025A}': // ɚ  [LATIN SMALL LETTER SCHWA WITH HOOK]
    case '\u{1D8F}': // ᶏ  [LATIN SMALL LETTER A WITH RETROFLEX HOOK]
    case '\u{1D95}': // ᶕ  [LATIN SMALL LETTER SCHWA WITH RETROFLEX HOOK]
    case '\u{1E01}': // ạ  [LATIN SMALL LETTER A WITH RING BELOW]
    case '\u{1E9A}': // ả  [LATIN SMALL LETTER A WITH RIGHT HALF RING]
    case '\u{1EA1}': // ạ  [LATIN SMALL LETTER A WITH DOT BELOW]
    case '\u{1EA3}': // ả  [LATIN SMALL LETTER A WITH HOOK ABOVE]
    case '\u{1EA5}': // ấ  [LATIN SMALL LETTER A WITH CIRCUMFLEX AND ACUTE]
    case '\u{1EA7}': // ầ  [LATIN SMALL LETTER A WITH CIRCUMFLEX AND GRAVE]
    case '\u{1EA9}': // ẩ  [LATIN SMALL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE]
    case '\u{1EAB}': // ẫ  [LATIN SMALL LETTER A WITH CIRCUMFLEX AND TILDE]
    case '\u{1EAD}': // ậ  [LATIN SMALL LETTER A WITH CIRCUMFLEX AND DOT BELOW]
    case '\u{1EAF}': // ắ  [LATIN SMALL LETTER A WITH BREVE AND ACUTE]
    case '\u{1EB1}': // ằ  [LATIN SMALL LETTER A WITH BREVE AND GRAVE]
    case '\u{1EB3}': // ẳ  [LATIN SMALL LETTER A WITH BREVE AND HOOK ABOVE]
    case '\u{1EB5}': // ẵ  [LATIN SMALL LETTER A WITH BREVE AND TILDE]
    case '\u{1EB7}': // ặ  [LATIN SMALL LETTER A WITH BREVE AND DOT BELOW]
    case '\u{2090}': // ₐ  [LATIN SUBSCRIPT SMALL LETTER A]
    case '\u{2094}': // ₔ  [LATIN SUBSCRIPT SMALL LETTER SCHWA]
    case '\u{24D0}': // ⓐ  [CIRCLED LATIN SMALL LETTER A]
    case '\u{2C65}': // ⱥ  [LATIN SMALL LETTER A WITH STROKE]
    case '\u{2C6F}': // Ɐ  [LATIN CAPITAL LETTER TURNED A]
    case '\u{FF41}': // ａ  [FULLWIDTH LATIN SMALL LETTER A]
      return 'a'
    case '\u{A732}': // Ꜳ  [LATIN CAPITAL LETTER AA]
      return 'AA'
    case '\u{00C6}': // Æ  [LATIN CAPITAL LETTER AE]
    case '\u{01E2}': // Ǣ  [LATIN CAPITAL LETTER AE WITH MACRON]
    case '\u{01FC}': // Ǽ  [LATIN CAPITAL LETTER AE WITH ACUTE]
    case '\u{1D01}': // ᴁ  [LATIN LETTER SMALL CAPITAL AE]
      return 'AE'
    case '\u{A734}': // Ꜵ  [LATIN CAPITAL LETTER AO]
      return 'AO'
    case '\u{A736}': // Ꜷ  [LATIN CAPITAL LETTER AU]
      return 'AU'
    case '\u{A738}': // Ꜹ  [LATIN CAPITAL LETTER AV]
    case '\u{A73A}': // Ꜻ  [LATIN CAPITAL LETTER AV WITH HORIZONTAL BAR]
      return 'AV'
    case '\u{A73C}': // Ꜽ  [LATIN CAPITAL LETTER AY]
      return 'AY'
    case '\u{249C}': // ⒜  [PARENTHESIZED LATIN SMALL LETTER A]
      return '(a)'
    case '\u{A733}': // ꜳ  [LATIN SMALL LETTER AA]
      return 'aa'
    case '\u{00E6}': // æ  [LATIN SMALL LETTER AE]
    case '\u{01E3}': // ǣ  [LATIN SMALL LETTER AE WITH MACRON]
    case '\u{01FD}': // ǽ  [LATIN SMALL LETTER AE WITH ACUTE]
    case '\u{1D02}': // ᴂ  [LATIN SMALL LETTER TURNED AE]
      return 'ae'
    case '\u{A735}': // ꜵ  [LATIN SMALL LETTER AO]
      return 'ao'
    case '\u{A737}': // ꜷ  [LATIN SMALL LETTER AU]
      return 'au'
    case '\u{A739}': // ꜹ  [LATIN SMALL LETTER AV]
    case '\u{A73B}': // ꜻ  [LATIN SMALL LETTER AV WITH HORIZONTAL BAR]
      return 'av'
    case '\u{A73D}': // ꜽ  [LATIN SMALL LETTER AY]
      return 'ay'
    case '\u{0181}': // Ɓ  [LATIN CAPITAL LETTER B WITH HOOK]
    case '\u{0182}': // Ƃ  [LATIN CAPITAL LETTER B WITH TOPBAR]
    case '\u{0243}': // Ƀ  [LATIN CAPITAL LETTER B WITH STROKE]
    case '\u{0299}': // ʙ  [LATIN LETTER SMALL CAPITAL B]
    case '\u{1D03}': // ᴃ  [LATIN LETTER SMALL CAPITAL BARRED B]
    case '\u{1E02}': // Ḃ  [LATIN CAPITAL LETTER B WITH DOT ABOVE]
    case '\u{1E04}': // Ḅ  [LATIN CAPITAL LETTER B WITH DOT BELOW]
    case '\u{1E06}': // Ḇ  [LATIN CAPITAL LETTER B WITH LINE BELOW]
    case '\u{24B7}': // Ⓑ  [CIRCLED LATIN CAPITAL LETTER B]
    case '\u{FF22}': // Ｂ  [FULLWIDTH LATIN CAPITAL LETTER B]
      return 'B'
    case '\u{0180}': // ƀ  [LATIN SMALL LETTER B WITH STROKE]
    case '\u{0183}': // ƃ  [LATIN SMALL LETTER B WITH TOPBAR]
    case '\u{0253}': // ɓ  [LATIN SMALL LETTER B WITH HOOK]
    case '\u{1D6C}': // ᵬ  [LATIN SMALL LETTER B WITH MIDDLE TILDE]
    case '\u{1D80}': // ᶀ  [LATIN SMALL LETTER B WITH PALATAL HOOK]
    case '\u{1E03}': // ḃ  [LATIN SMALL LETTER B WITH DOT ABOVE]
    case '\u{1E05}': // ḅ  [LATIN SMALL LETTER B WITH DOT BELOW]
    case '\u{1E07}': // ḇ  [LATIN SMALL LETTER B WITH LINE BELOW]
    case '\u{24D1}': // ⓑ  [CIRCLED LATIN SMALL LETTER B]
    case '\u{FF42}': // ｂ  [FULLWIDTH LATIN SMALL LETTER B]
      return 'b'
    case '\u{249D}': // ⒝  [PARENTHESIZED LATIN SMALL LETTER B]
      return '(b)'
    case '\u{00C7}': // Ç  [LATIN CAPITAL LETTER C WITH CEDILLA]
    case '\u{0106}': // Ć  [LATIN CAPITAL LETTER C WITH ACUTE]
    case '\u{0108}': // Ĉ  [LATIN CAPITAL LETTER C WITH CIRCUMFLEX]
    case '\u{010A}': // Ċ  [LATIN CAPITAL LETTER C WITH DOT ABOVE]
    case '\u{010C}': // Č  [LATIN CAPITAL LETTER C WITH CARON]
    case '\u{0187}': // Ƈ  [LATIN CAPITAL LETTER C WITH HOOK]
    case '\u{023B}': // Ȼ  [LATIN CAPITAL LETTER C WITH STROKE]
    case '\u{0297}': // ʗ  [LATIN LETTER STRETCHED C]
    case '\u{1D04}': // ᴄ  [LATIN LETTER SMALL CAPITAL C]
    case '\u{1E08}': // Ḉ  [LATIN CAPITAL LETTER C WITH CEDILLA AND ACUTE]
    case '\u{24B8}': // Ⓒ  [CIRCLED LATIN CAPITAL LETTER C]
    case '\u{FF23}': // Ｃ  [FULLWIDTH LATIN CAPITAL LETTER C]
      return 'C'
    case '\u{00E7}': // ç  [LATIN SMALL LETTER C WITH CEDILLA]
    case '\u{0107}': // ć  [LATIN SMALL LETTER C WITH ACUTE]
    case '\u{0109}': // ĉ  [LATIN SMALL LETTER C WITH CIRCUMFLEX]
    case '\u{010B}': // ċ  [LATIN SMALL LETTER C WITH DOT ABOVE]
    case '\u{010D}': // č  [LATIN SMALL LETTER C WITH CARON]
    case '\u{0188}': // ƈ  [LATIN SMALL LETTER C WITH HOOK]
    case '\u{023C}': // ȼ  [LATIN SMALL LETTER C WITH STROKE]
    case '\u{0255}': // ɕ  [LATIN SMALL LETTER C WITH CURL]
    case '\u{1E09}': // ḉ  [LATIN SMALL LETTER C WITH CEDILLA AND ACUTE]
    case '\u{2184}': // ↄ  [LATIN SMALL LETTER REVERSED C]
    case '\u{24D2}': // ⓒ  [CIRCLED LATIN SMALL LETTER C]
    case '\u{A73E}': // Ꜿ  [LATIN CAPITAL LETTER REVERSED C WITH DOT]
    case '\u{A73F}': // ꜿ  [LATIN SMALL LETTER REVERSED C WITH DOT]
    case '\u{FF43}': // ｃ  [FULLWIDTH LATIN SMALL LETTER C]
      return 'c'
    case '\u{249E}': // ⒞  [PARENTHESIZED LATIN SMALL LETTER C]
      return '(c)'
    case '\u{00D0}': // Ð  [LATIN CAPITAL LETTER ETH]
    case '\u{010E}': // Ď  [LATIN CAPITAL LETTER D WITH CARON]
    case '\u{0110}': // Đ  [LATIN CAPITAL LETTER D WITH STROKE]
    case '\u{0189}': // Ɖ  [LATIN CAPITAL LETTER AFRICAN D]
    case '\u{018A}': // Ɗ  [LATIN CAPITAL LETTER D WITH HOOK]
    case '\u{018B}': // Ƌ  [LATIN CAPITAL LETTER D WITH TOPBAR]
    case '\u{1D05}': // ᴅ  [LATIN LETTER SMALL CAPITAL D]
    case '\u{1D06}': // ᴆ  [LATIN LETTER SMALL CAPITAL ETH]
    case '\u{1E0A}': // Ḋ  [LATIN CAPITAL LETTER D WITH DOT ABOVE]
    case '\u{1E0C}': // Ḍ  [LATIN CAPITAL LETTER D WITH DOT BELOW]
    case '\u{1E0E}': // Ḏ  [LATIN CAPITAL LETTER D WITH LINE BELOW]
    case '\u{1E10}': // Ḑ  [LATIN CAPITAL LETTER D WITH CEDILLA]
    case '\u{1E12}': // Ḓ  [LATIN CAPITAL LETTER D WITH CIRCUMFLEX BELOW]
    case '\u{24B9}': // Ⓓ  [CIRCLED LATIN CAPITAL LETTER D]
    case '\u{A779}': // Ꝺ  [LATIN CAPITAL LETTER INSULAR D]
    case '\u{FF24}': // Ｄ  [FULLWIDTH LATIN CAPITAL LETTER D]
      return 'D'
    case '\u{00F0}': // ð  [LATIN SMALL LETTER ETH]
    case '\u{010F}': // ď  [LATIN SMALL LETTER D WITH CARON]
    case '\u{0111}': // đ  [LATIN SMALL LETTER D WITH STROKE]
    case '\u{018C}': // ƌ  [LATIN SMALL LETTER D WITH TOPBAR]
    case '\u{0221}': // ȡ  [LATIN SMALL LETTER D WITH CURL]
    case '\u{0256}': // ɖ  [LATIN SMALL LETTER D WITH TAIL]
    case '\u{0257}': // ɗ  [LATIN SMALL LETTER D WITH HOOK]
    case '\u{1D6D}': // ᵭ  [LATIN SMALL LETTER D WITH MIDDLE TILDE]
    case '\u{1D81}': // ᶁ  [LATIN SMALL LETTER D WITH PALATAL HOOK]
    case '\u{1D91}': // ᶑ  [LATIN SMALL LETTER D WITH HOOK AND TAIL]
    case '\u{1E0B}': // ḋ  [LATIN SMALL LETTER D WITH DOT ABOVE]
    case '\u{1E0D}': // ḍ  [LATIN SMALL LETTER D WITH DOT BELOW]
    case '\u{1E0F}': // ḏ  [LATIN SMALL LETTER D WITH LINE BELOW]
    case '\u{1E11}': // ḑ  [LATIN SMALL LETTER D WITH CEDILLA]
    case '\u{1E13}': // ḓ  [LATIN SMALL LETTER D WITH CIRCUMFLEX BELOW]
    case '\u{24D3}': // ⓓ  [CIRCLED LATIN SMALL LETTER D]
    case '\u{A77A}': // ꝺ  [LATIN SMALL LETTER INSULAR D]
    case '\u{FF44}': // ｄ  [FULLWIDTH LATIN SMALL LETTER D]
      return 'd'
    case '\u{01C4}': // Ǆ  [LATIN CAPITAL LETTER DZ WITH CARON]
    case '\u{01F1}': // Ǳ  [LATIN CAPITAL LETTER DZ]
      return 'DZ'
    case '\u{01C5}': // ǅ  [LATIN CAPITAL LETTER D WITH SMALL LETTER Z WITH CARON]
    case '\u{01F2}': // ǲ  [LATIN CAPITAL LETTER D WITH SMALL LETTER Z]
      return 'dz'
    case '\u{249F}': // ⒟  [PARENTHESIZED LATIN SMALL LETTER D]
      return '(d)'
    case '\u{0238}': // ȸ  [LATIN SMALL LETTER DB DIGRAPH]
      return 'db'
    case '\u{01C6}': // ǆ  [LATIN SMALL LETTER DZ WITH CARON]
    case '\u{01F3}': // ǳ  [LATIN SMALL LETTER DZ]
    case '\u{02A3}': // ʣ  [LATIN SMALL LETTER DZ DIGRAPH]
    case '\u{02A5}': // ʥ  [LATIN SMALL LETTER DZ DIGRAPH WITH CURL]
      return 'dz'
    case '\u{00C8}': // È  [LATIN CAPITAL LETTER E WITH GRAVE]
    case '\u{00C9}': // É  [LATIN CAPITAL LETTER E WITH ACUTE]
    case '\u{00CA}': // Ê  [LATIN CAPITAL LETTER E WITH CIRCUMFLEX]
    case '\u{00CB}': // Ë  [LATIN CAPITAL LETTER E WITH DIAERESIS]
    case '\u{0112}': // Ē  [LATIN CAPITAL LETTER E WITH MACRON]
    case '\u{0114}': // Ĕ  [LATIN CAPITAL LETTER E WITH BREVE]
    case '\u{0116}': // Ė  [LATIN CAPITAL LETTER E WITH DOT ABOVE]
    case '\u{0118}': // Ę  [LATIN CAPITAL LETTER E WITH OGONEK]
    case '\u{011A}': // Ě  [LATIN CAPITAL LETTER E WITH CARON]
    case '\u{018E}': // Ǝ  [LATIN CAPITAL LETTER REVERSED E]
    case '\u{0190}': // Ɛ  [LATIN CAPITAL LETTER OPEN E]
    case '\u{0204}': // Ȅ  [LATIN CAPITAL LETTER E WITH DOUBLE GRAVE]
    case '\u{0206}': // Ȇ  [LATIN CAPITAL LETTER E WITH INVERTED BREVE]
    case '\u{0228}': // Ȩ  [LATIN CAPITAL LETTER E WITH CEDILLA]
    case '\u{0246}': // Ɇ  [LATIN CAPITAL LETTER E WITH STROKE]
    case '\u{1D07}': // ᴇ  [LATIN LETTER SMALL CAPITAL E]
    case '\u{1E14}': // Ḕ  [LATIN CAPITAL LETTER E WITH MACRON AND GRAVE]
    case '\u{1E16}': // Ḗ  [LATIN CAPITAL LETTER E WITH MACRON AND ACUTE]
    case '\u{1E18}': // Ḙ  [LATIN CAPITAL LETTER E WITH CIRCUMFLEX BELOW]
    case '\u{1E1A}': // Ḛ  [LATIN CAPITAL LETTER E WITH TILDE BELOW]
    case '\u{1E1C}': // Ḝ  [LATIN CAPITAL LETTER E WITH CEDILLA AND BREVE]
    case '\u{1EB8}': // Ẹ  [LATIN CAPITAL LETTER E WITH DOT BELOW]
    case '\u{1EBA}': // Ẻ  [LATIN CAPITAL LETTER E WITH HOOK ABOVE]
    case '\u{1EBC}': // Ẽ  [LATIN CAPITAL LETTER E WITH TILDE]
    case '\u{1EBE}': // Ế  [LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND ACUTE]
    case '\u{1EC0}': // Ề  [LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND GRAVE]
    case '\u{1EC2}': // Ể  [LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE]
    case '\u{1EC4}': // Ễ  [LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND TILDE]
    case '\u{1EC6}': // Ệ  [LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND DOT BELOW]
    case '\u{24BA}': // Ⓔ  [CIRCLED LATIN CAPITAL LETTER E]
    case '\u{2C7B}': // ⱻ  [LATIN LETTER SMALL CAPITAL TURNED E]
    case '\u{FF25}': // Ｅ  [FULLWIDTH LATIN CAPITAL LETTER E]
      return 'E'
    case '\u{00E8}': // è  [LATIN SMALL LETTER E WITH GRAVE]
    case '\u{00E9}': // é  [LATIN SMALL LETTER E WITH ACUTE]
    case '\u{00EA}': // ê  [LATIN SMALL LETTER E WITH CIRCUMFLEX]
    case '\u{00EB}': // ë  [LATIN SMALL LETTER E WITH DIAERESIS]
    case '\u{0113}': // ē  [LATIN SMALL LETTER E WITH MACRON]
    case '\u{0115}': // ĕ  [LATIN SMALL LETTER E WITH BREVE]
    case '\u{0117}': // ė  [LATIN SMALL LETTER E WITH DOT ABOVE]
    case '\u{0119}': // ę  [LATIN SMALL LETTER E WITH OGONEK]
    case '\u{011B}': // ě  [LATIN SMALL LETTER E WITH CARON]
    case '\u{01DD}': // ǝ  [LATIN SMALL LETTER TURNED E]
    case '\u{0205}': // ȅ  [LATIN SMALL LETTER E WITH DOUBLE GRAVE]
    case '\u{0207}': // ȇ  [LATIN SMALL LETTER E WITH INVERTED BREVE]
    case '\u{0229}': // ȩ  [LATIN SMALL LETTER E WITH CEDILLA]
    case '\u{0247}': // ɇ  [LATIN SMALL LETTER E WITH STROKE]
    case '\u{0258}': // ɘ  [LATIN SMALL LETTER REVERSED E]
    case '\u{025B}': // ɛ  [LATIN SMALL LETTER OPEN E]
    case '\u{025C}': // ɜ  [LATIN SMALL LETTER REVERSED OPEN E]
    case '\u{025D}': // ɝ  [LATIN SMALL LETTER REVERSED OPEN E WITH HOOK]
    case '\u{025E}': // ɞ  [LATIN SMALL LETTER CLOSED REVERSED OPEN E]
    case '\u{029A}': // ʚ  [LATIN SMALL LETTER CLOSED OPEN E]
    case '\u{1D08}': // ᴈ  [LATIN SMALL LETTER TURNED OPEN E]
    case '\u{1D92}': // ᶒ  [LATIN SMALL LETTER E WITH RETROFLEX HOOK]
    case '\u{1D93}': // ᶓ  [LATIN SMALL LETTER OPEN E WITH RETROFLEX HOOK]
    case '\u{1D94}': // ᶔ  [LATIN SMALL LETTER REVERSED OPEN E WITH RETROFLEX HOOK]
    case '\u{1E15}': // ḕ  [LATIN SMALL LETTER E WITH MACRON AND GRAVE]
    case '\u{1E17}': // ḗ  [LATIN SMALL LETTER E WITH MACRON AND ACUTE]
    case '\u{1E19}': // ḙ  [LATIN SMALL LETTER E WITH CIRCUMFLEX BELOW]
    case '\u{1E1B}': // ḛ  [LATIN SMALL LETTER E WITH TILDE BELOW]
    case '\u{1E1D}': // ḝ  [LATIN SMALL LETTER E WITH CEDILLA AND BREVE]
    case '\u{1EB9}': // ẹ  [LATIN SMALL LETTER E WITH DOT BELOW]
    case '\u{1EBB}': // ẻ  [LATIN SMALL LETTER E WITH HOOK ABOVE]
    case '\u{1EBD}': // ẽ  [LATIN SMALL LETTER E WITH TILDE]
    case '\u{1EBF}': // ế  [LATIN SMALL LETTER E WITH CIRCUMFLEX AND ACUTE]
    case '\u{1EC1}': // ề  [LATIN SMALL LETTER E WITH CIRCUMFLEX AND GRAVE]
    case '\u{1EC3}': // ể  [LATIN SMALL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE]
    case '\u{1EC5}': // ễ  [LATIN SMALL LETTER E WITH CIRCUMFLEX AND TILDE]
    case '\u{1EC7}': // ệ  [LATIN SMALL LETTER E WITH CIRCUMFLEX AND DOT BELOW]
    case '\u{2091}': // ₑ  [LATIN SUBSCRIPT SMALL LETTER E]
    case '\u{24D4}': // ⓔ  [CIRCLED LATIN SMALL LETTER E]
    case '\u{2C78}': // ⱸ  [LATIN SMALL LETTER E WITH NOTCH]
    case '\u{FF45}': // ｅ  [FULLWIDTH LATIN SMALL LETTER E]
      return 'e'
    case '\u{24A0}': // ⒠  [PARENTHESIZED LATIN SMALL LETTER E]
      return '(e)'
    case '\u{0191}': // Ƒ  [LATIN CAPITAL LETTER F WITH HOOK]
    case '\u{1E1E}': // Ḟ  [LATIN CAPITAL LETTER F WITH DOT ABOVE]
    case '\u{24BB}': // Ⓕ  [CIRCLED LATIN CAPITAL LETTER F]
    case '\u{A730}': // ꜰ  [LATIN LETTER SMALL CAPITAL F]
    case '\u{A77B}': // Ꝼ  [LATIN CAPITAL LETTER INSULAR F]
    case '\u{A7FB}': // ꟻ  [LATIN EPIGRAPHIC LETTER REVERSED F]
    case '\u{FF26}': // Ｆ  [FULLWIDTH LATIN CAPITAL LETTER F]
      return 'F'
    case '\u{0192}': // ƒ  [LATIN SMALL LETTER F WITH HOOK]
    case '\u{1D6E}': // ᵮ  [LATIN SMALL LETTER F WITH MIDDLE TILDE]
    case '\u{1D82}': // ᶂ  [LATIN SMALL LETTER F WITH PALATAL HOOK]
    case '\u{1E1F}': // ḟ  [LATIN SMALL LETTER F WITH DOT ABOVE]
    case '\u{1E9B}': // ẛ  [LATIN SMALL LETTER LONG S WITH DOT ABOVE]
    case '\u{24D5}': // ⓕ  [CIRCLED LATIN SMALL LETTER F]
    case '\u{A77C}': // ꝼ  [LATIN SMALL LETTER INSULAR F]
    case '\u{FF46}': // ｆ  [FULLWIDTH LATIN SMALL LETTER F]
      return 'f'
    case '\u{24A1}': // ⒡  [PARENTHESIZED LATIN SMALL LETTER F]
      return '(f)'
    case '\u{FB00}': // ﬀ  [LATIN SMALL LIGATURE FF]
      return 'ff'
    case '\u{FB03}': // ﬃ  [LATIN SMALL LIGATURE FFI]
      return 'ffi'
    case '\u{FB04}': // ﬄ  [LATIN SMALL LIGATURE FFL]
      return 'ffl'
    case '\u{FB01}': // ﬁ  [LATIN SMALL LIGATURE FI]
      return 'fi'
    case '\u{FB02}': // ﬂ  [LATIN SMALL LIGATURE FL]
      return 'fl'
    case '\u{011C}': // Ĝ  [LATIN CAPITAL LETTER G WITH CIRCUMFLEX]
    case '\u{011E}': // Ğ  [LATIN CAPITAL LETTER G WITH BREVE]
    case '\u{0120}': // Ġ  [LATIN CAPITAL LETTER G WITH DOT ABOVE]
    case '\u{0122}': // Ģ  [LATIN CAPITAL LETTER G WITH CEDILLA]
    case '\u{0193}': // Ɠ  [LATIN CAPITAL LETTER G WITH HOOK]
    case '\u{01E4}': // Ǥ  [LATIN CAPITAL LETTER G WITH STROKE]
    case '\u{01E5}': // ǥ  [LATIN SMALL LETTER G WITH STROKE]
    case '\u{01E6}': // Ǧ  [LATIN CAPITAL LETTER G WITH CARON]
    case '\u{01E7}': // ǧ  [LATIN SMALL LETTER G WITH CARON]
    case '\u{01F4}': // Ǵ  [LATIN CAPITAL LETTER G WITH ACUTE]
    case '\u{0262}': // ɢ  [LATIN LETTER SMALL CAPITAL G]
    case '\u{029B}': // ʛ  [LATIN LETTER SMALL CAPITAL G WITH HOOK]
    case '\u{1E20}': // Ḡ  [LATIN CAPITAL LETTER G WITH MACRON]
    case '\u{24BC}': // Ⓖ  [CIRCLED LATIN CAPITAL LETTER G]
    case '\u{A77D}': // Ᵹ  [LATIN CAPITAL LETTER INSULAR G]
    case '\u{A77E}': // Ꝿ  [LATIN CAPITAL LETTER TURNED INSULAR G]
    case '\u{FF27}': // Ｇ  [FULLWIDTH LATIN CAPITAL LETTER G]
      return 'G'
    case '\u{011D}': // ĝ  [LATIN SMALL LETTER G WITH CIRCUMFLEX]
    case '\u{011F}': // ğ  [LATIN SMALL LETTER G WITH BREVE]
    case '\u{0121}': // ġ  [LATIN SMALL LETTER G WITH DOT ABOVE]
    case '\u{0123}': // ģ  [LATIN SMALL LETTER G WITH CEDILLA]
    case '\u{01F5}': // ǵ  [LATIN SMALL LETTER G WITH ACUTE]
    case '\u{0260}': // ɠ  [LATIN SMALL LETTER G WITH HOOK]
    case '\u{0261}': // ɡ  [LATIN SMALL LETTER SCRIPT G]
    case '\u{1D77}': // ᵷ  [LATIN SMALL LETTER TURNED G]
    case '\u{1D79}': // ᵹ  [LATIN SMALL LETTER INSULAR G]
    case '\u{1D83}': // ᶃ  [LATIN SMALL LETTER G WITH PALATAL HOOK]
    case '\u{1E21}': // ḡ  [LATIN SMALL LETTER G WITH MACRON]
    case '\u{24D6}': // ⓖ  [CIRCLED LATIN SMALL LETTER G]
    case '\u{A77F}': // ꝿ  [LATIN SMALL LETTER TURNED INSULAR G]
    case '\u{FF47}': // ｇ  [FULLWIDTH LATIN SMALL LETTER G]
      return 'g'
    case '\u{24A2}': // ⒢  [PARENTHESIZED LATIN SMALL LETTER G]
      return '(g)'
    case '\u{0124}': // Ĥ  [LATIN CAPITAL LETTER H WITH CIRCUMFLEX]
    case '\u{0126}': // Ħ  [LATIN CAPITAL LETTER H WITH STROKE]
    case '\u{021E}': // Ȟ  [LATIN CAPITAL LETTER H WITH CARON]
    case '\u{029C}': // ʜ  [LATIN LETTER SMALL CAPITAL H]
    case '\u{1E22}': // Ḣ  [LATIN CAPITAL LETTER H WITH DOT ABOVE]
    case '\u{1E24}': // Ḥ  [LATIN CAPITAL LETTER H WITH DOT BELOW]
    case '\u{1E26}': // Ḧ  [LATIN CAPITAL LETTER H WITH DIAERESIS]
    case '\u{1E28}': // Ḩ  [LATIN CAPITAL LETTER H WITH CEDILLA]
    case '\u{1E2A}': // Ḫ  [LATIN CAPITAL LETTER H WITH BREVE BELOW]
    case '\u{24BD}': // Ⓗ  [CIRCLED LATIN CAPITAL LETTER H]
    case '\u{2C67}': // Ⱨ  [LATIN CAPITAL LETTER H WITH DESCENDER]
    case '\u{2C75}': // Ⱶ  [LATIN CAPITAL LETTER HALF H]
    case '\u{FF28}': // Ｈ  [FULLWIDTH LATIN CAPITAL LETTER H]
      return 'H'
    case '\u{0125}': // ĥ  [LATIN SMALL LETTER H WITH CIRCUMFLEX]
    case '\u{0127}': // ħ  [LATIN SMALL LETTER H WITH STROKE]
    case '\u{021F}': // ȟ  [LATIN SMALL LETTER H WITH CARON]
    case '\u{0265}': // ɥ  [LATIN SMALL LETTER TURNED H]
    case '\u{0266}': // ɦ  [LATIN SMALL LETTER H WITH HOOK]
    case '\u{02AE}': // ʮ  [LATIN SMALL LETTER TURNED H WITH FISHHOOK]
    case '\u{02AF}': // ʯ  [LATIN SMALL LETTER TURNED H WITH FISHHOOK AND TAIL]
    case '\u{1E23}': // ḣ  [LATIN SMALL LETTER H WITH DOT ABOVE]
    case '\u{1E25}': // ḥ  [LATIN SMALL LETTER H WITH DOT BELOW]
    case '\u{1E27}': // ḧ  [LATIN SMALL LETTER H WITH DIAERESIS]
    case '\u{1E29}': // ḩ  [LATIN SMALL LETTER H WITH CEDILLA]
    case '\u{1E2B}': // ḫ  [LATIN SMALL LETTER H WITH BREVE BELOW]
    case '\u{1E96}': // ẖ  [LATIN SMALL LETTER H WITH LINE BELOW]
    case '\u{24D7}': // ⓗ  [CIRCLED LATIN SMALL LETTER H]
    case '\u{2C68}': // ⱨ  [LATIN SMALL LETTER H WITH DESCENDER]
    case '\u{2C76}': // ⱶ  [LATIN SMALL LETTER HALF H]
    case '\u{FF48}': // ｈ  [FULLWIDTH LATIN SMALL LETTER H]
      return 'h'
    case '\u{01F6}': // Ƕ  http://en.wikipedia.org/wiki/Hwair  [LATIN CAPITAL LETTER HWAIR]
      return 'HV'
    case '\u{24A3}': // ⒣  [PARENTHESIZED LATIN SMALL LETTER H]
      return '(h)'
    case '\u{0195}': // ƕ  [LATIN SMALL LETTER HV]
      return 'hv'
    case '\u{00CC}': // Ì  [LATIN CAPITAL LETTER I WITH GRAVE]
    case '\u{00CD}': // Í  [LATIN CAPITAL LETTER I WITH ACUTE]
    case '\u{00CE}': // Î  [LATIN CAPITAL LETTER I WITH CIRCUMFLEX]
    case '\u{00CF}': // Ï  [LATIN CAPITAL LETTER I WITH DIAERESIS]
    case '\u{0128}': // Ĩ  [LATIN CAPITAL LETTER I WITH TILDE]
    case '\u{012A}': // Ī  [LATIN CAPITAL LETTER I WITH MACRON]
    case '\u{012C}': // Ĭ  [LATIN CAPITAL LETTER I WITH BREVE]
    case '\u{012E}': // Į  [LATIN CAPITAL LETTER I WITH OGONEK]
    case '\u{0130}': // İ  [LATIN CAPITAL LETTER I WITH DOT ABOVE]
    case '\u{0196}': // Ɩ  [LATIN CAPITAL LETTER IOTA]
    case '\u{0197}': // Ɨ  [LATIN CAPITAL LETTER I WITH STROKE]
    case '\u{01CF}': // Ǐ  [LATIN CAPITAL LETTER I WITH CARON]
    case '\u{0208}': // Ȉ  [LATIN CAPITAL LETTER I WITH DOUBLE GRAVE]
    case '\u{020A}': // Ȋ  [LATIN CAPITAL LETTER I WITH INVERTED BREVE]
    case '\u{026A}': // ɪ  [LATIN LETTER SMALL CAPITAL I]
    case '\u{1D7B}': // ᵻ  [LATIN SMALL CAPITAL LETTER I WITH STROKE]
    case '\u{1E2C}': // Ḭ  [LATIN CAPITAL LETTER I WITH TILDE BELOW]
    case '\u{1E2E}': // Ḯ  [LATIN CAPITAL LETTER I WITH DIAERESIS AND ACUTE]
    case '\u{1EC8}': // Ỉ  [LATIN CAPITAL LETTER I WITH HOOK ABOVE]
    case '\u{1ECA}': // Ị  [LATIN CAPITAL LETTER I WITH DOT BELOW]
    case '\u{24BE}': // Ⓘ  [CIRCLED LATIN CAPITAL LETTER I]
    case '\u{A7FE}': // ꟾ  [LATIN EPIGRAPHIC LETTER I LONGA]
    case '\u{FF29}': // Ｉ  [FULLWIDTH LATIN CAPITAL LETTER I]
      return 'I'
    case '\u{00EC}': // ì  [LATIN SMALL LETTER I WITH GRAVE]
    case '\u{00ED}': // í  [LATIN SMALL LETTER I WITH ACUTE]
    case '\u{00EE}': // î  [LATIN SMALL LETTER I WITH CIRCUMFLEX]
    case '\u{00EF}': // ï  [LATIN SMALL LETTER I WITH DIAERESIS]
    case '\u{0129}': // ĩ  [LATIN SMALL LETTER I WITH TILDE]
    case '\u{012B}': // ī  [LATIN SMALL LETTER I WITH MACRON]
    case '\u{012D}': // ĭ  [LATIN SMALL LETTER I WITH BREVE]
    case '\u{012F}': // į  [LATIN SMALL LETTER I WITH OGONEK]
    case '\u{0131}': // ı  [LATIN SMALL LETTER DOTLESS I]
    case '\u{01D0}': // ǐ  [LATIN SMALL LETTER I WITH CARON]
    case '\u{0209}': // ȉ  [LATIN SMALL LETTER I WITH DOUBLE GRAVE]
    case '\u{020B}': // ȋ  [LATIN SMALL LETTER I WITH INVERTED BREVE]
    case '\u{0268}': // ɨ  [LATIN SMALL LETTER I WITH STROKE]
    case '\u{1D09}': // ᴉ  [LATIN SMALL LETTER TURNED I]
    case '\u{1D62}': // ᵢ  [LATIN SUBSCRIPT SMALL LETTER I]
    case '\u{1D7C}': // ᵼ  [LATIN SMALL LETTER IOTA WITH STROKE]
    case '\u{1D96}': // ᶖ  [LATIN SMALL LETTER I WITH RETROFLEX HOOK]
    case '\u{1E2D}': // ḭ  [LATIN SMALL LETTER I WITH TILDE BELOW]
    case '\u{1E2F}': // ḯ  [LATIN SMALL LETTER I WITH DIAERESIS AND ACUTE]
    case '\u{1EC9}': // ỉ  [LATIN SMALL LETTER I WITH HOOK ABOVE]
    case '\u{1ECB}': // ị  [LATIN SMALL LETTER I WITH DOT BELOW]
    case '\u{2071}': // ⁱ  [SUPERSCRIPT LATIN SMALL LETTER I]
    case '\u{24D8}': // ⓘ  [CIRCLED LATIN SMALL LETTER I]
    case '\u{FF49}': // ｉ  [FULLWIDTH LATIN SMALL LETTER I]
      return 'i'
    case '\u{0132}': // Ĳ  [LATIN CAPITAL LIGATURE IJ]
      return 'IJ'
    case '\u{24A4}': // ⒤  [PARENTHESIZED LATIN SMALL LETTER I]
      return '(i)'
    case '\u{0133}': // ĳ  [LATIN SMALL LIGATURE IJ]
      return 'ij'
    case '\u{0134}': // Ĵ  [LATIN CAPITAL LETTER J WITH CIRCUMFLEX]
    case '\u{0248}': // Ɉ  [LATIN CAPITAL LETTER J WITH STROKE]
    case '\u{1D0A}': // ᴊ  [LATIN LETTER SMALL CAPITAL J]
    case '\u{24BF}': // Ⓙ  [CIRCLED LATIN CAPITAL LETTER J]
    case '\u{FF2A}': // Ｊ  [FULLWIDTH LATIN CAPITAL LETTER J]
      return 'J'
    case '\u{0135}': // ĵ  [LATIN SMALL LETTER J WITH CIRCUMFLEX]
    case '\u{01F0}': // ǰ  [LATIN SMALL LETTER J WITH CARON]
    case '\u{0237}': // ȷ  [LATIN SMALL LETTER DOTLESS J]
    case '\u{0249}': // ɉ  [LATIN SMALL LETTER J WITH STROKE]
    case '\u{025F}': // ɟ  [LATIN SMALL LETTER DOTLESS J WITH STROKE]
    case '\u{0284}': // ʄ  [LATIN SMALL LETTER DOTLESS J WITH STROKE AND HOOK]
    case '\u{029D}': // ʝ  [LATIN SMALL LETTER J WITH CROSSED-TAIL]
    case '\u{24D9}': // ⓙ  [CIRCLED LATIN SMALL LETTER J]
    case '\u{2C7C}': // ⱼ  [LATIN SUBSCRIPT SMALL LETTER J]
    case '\u{FF4A}': // ｊ  [FULLWIDTH LATIN SMALL LETTER J]
      return 'j'
    case '\u{24A5}': // ⒥  [PARENTHESIZED LATIN SMALL LETTER J]
      return '(j)'
    case '\u{0136}': // Ķ  [LATIN CAPITAL LETTER K WITH CEDILLA]
    case '\u{0198}': // Ƙ  [LATIN CAPITAL LETTER K WITH HOOK]
    case '\u{01E8}': // Ǩ  [LATIN CAPITAL LETTER K WITH CARON]
    case '\u{1D0B}': // ᴋ  [LATIN LETTER SMALL CAPITAL K]
    case '\u{1E30}': // Ḱ  [LATIN CAPITAL LETTER K WITH ACUTE]
    case '\u{1E32}': // Ḳ  [LATIN CAPITAL LETTER K WITH DOT BELOW]
    case '\u{1E34}': // Ḵ  [LATIN CAPITAL LETTER K WITH LINE BELOW]
    case '\u{24C0}': // Ⓚ  [CIRCLED LATIN CAPITAL LETTER K]
    case '\u{2C69}': // Ⱪ  [LATIN CAPITAL LETTER K WITH DESCENDER]
    case '\u{A740}': // Ꝁ  [LATIN CAPITAL LETTER K WITH STROKE]
    case '\u{A742}': // Ꝃ  [LATIN CAPITAL LETTER K WITH DIAGONAL STROKE]
    case '\u{A744}': // Ꝅ  [LATIN CAPITAL LETTER K WITH STROKE AND DIAGONAL STROKE]
    case '\u{FF2B}': // Ｋ  [FULLWIDTH LATIN CAPITAL LETTER K]
      return 'K'
    case '\u{0137}': // ķ  [LATIN SMALL LETTER K WITH CEDILLA]
    case '\u{0199}': // ƙ  [LATIN SMALL LETTER K WITH HOOK]
    case '\u{01E9}': // ǩ  [LATIN SMALL LETTER K WITH CARON]
    case '\u{029E}': // ʞ  [LATIN SMALL LETTER TURNED K]
    case '\u{1D84}': // ᶄ  [LATIN SMALL LETTER K WITH PALATAL HOOK]
    case '\u{1E31}': // ḱ  [LATIN SMALL LETTER K WITH ACUTE]
    case '\u{1E33}': // ḳ  [LATIN SMALL LETTER K WITH DOT BELOW]
    case '\u{1E35}': // ḵ  [LATIN SMALL LETTER K WITH LINE BELOW]
    case '\u{24DA}': // ⓚ  [CIRCLED LATIN SMALL LETTER K]
    case '\u{2C6A}': // ⱪ  [LATIN SMALL LETTER K WITH DESCENDER]
    case '\u{A741}': // ꝁ  [LATIN SMALL LETTER K WITH STROKE]
    case '\u{A743}': // ꝃ  [LATIN SMALL LETTER K WITH DIAGONAL STROKE]
    case '\u{A745}': // ꝅ  [LATIN SMALL LETTER K WITH STROKE AND DIAGONAL STROKE]
    case '\u{FF4B}': // ｋ  [FULLWIDTH LATIN SMALL LETTER K]
      return 'k'
    case '\u{24A6}': // ⒦  [PARENTHESIZED LATIN SMALL LETTER K]
      return '(k)'
    case '\u{0139}': // Ĺ  [LATIN CAPITAL LETTER L WITH ACUTE]
    case '\u{013B}': // Ļ  [LATIN CAPITAL LETTER L WITH CEDILLA]
    case '\u{013D}': // Ľ  [LATIN CAPITAL LETTER L WITH CARON]
    case '\u{013F}': // Ŀ  [LATIN CAPITAL LETTER L WITH MIDDLE DOT]
    case '\u{0141}': // Ł  [LATIN CAPITAL LETTER L WITH STROKE]
    case '\u{023D}': // Ƚ  [LATIN CAPITAL LETTER L WITH BAR]
    case '\u{029F}': // ʟ  [LATIN LETTER SMALL CAPITAL L]
    case '\u{1D0C}': // ᴌ  [LATIN LETTER SMALL CAPITAL L WITH STROKE]
    case '\u{1E36}': // Ḷ  [LATIN CAPITAL LETTER L WITH DOT BELOW]
    case '\u{1E38}': // Ḹ  [LATIN CAPITAL LETTER L WITH DOT BELOW AND MACRON]
    case '\u{1E3A}': // Ḻ  [LATIN CAPITAL LETTER L WITH LINE BELOW]
    case '\u{1E3C}': // Ḽ  [LATIN CAPITAL LETTER L WITH CIRCUMFLEX BELOW]
    case '\u{24C1}': // Ⓛ  [CIRCLED LATIN CAPITAL LETTER L]
    case '\u{2C60}': // Ⱡ  [LATIN CAPITAL LETTER L WITH DOUBLE BAR]
    case '\u{2C62}': // Ɫ  [LATIN CAPITAL LETTER L WITH MIDDLE TILDE]
    case '\u{A746}': // Ꝇ  [LATIN CAPITAL LETTER BROKEN L]
    case '\u{A748}': // Ꝉ  [LATIN CAPITAL LETTER L WITH HIGH STROKE]
    case '\u{A780}': // Ꞁ  [LATIN CAPITAL LETTER TURNED L]
    case '\u{FF2C}': // Ｌ  [FULLWIDTH LATIN CAPITAL LETTER L]
      return 'L'
    case '\u{013A}': // ĺ  [LATIN SMALL LETTER L WITH ACUTE]
    case '\u{013C}': // ļ  [LATIN SMALL LETTER L WITH CEDILLA]
    case '\u{013E}': // ľ  [LATIN SMALL LETTER L WITH CARON]
    case '\u{0140}': // ŀ  [LATIN SMALL LETTER L WITH MIDDLE DOT]
    case '\u{0142}': // ł  [LATIN SMALL LETTER L WITH STROKE]
    case '\u{019A}': // ƚ  [LATIN SMALL LETTER L WITH BAR]
    case '\u{0234}': // ȴ  [LATIN SMALL LETTER L WITH CURL]
    case '\u{026B}': // ɫ  [LATIN SMALL LETTER L WITH MIDDLE TILDE]
    case '\u{026C}': // ɬ  [LATIN SMALL LETTER L WITH BELT]
    case '\u{026D}': // ɭ  [LATIN SMALL LETTER L WITH RETROFLEX HOOK]
    case '\u{1D85}': // ᶅ  [LATIN SMALL LETTER L WITH PALATAL HOOK]
    case '\u{1E37}': // ḷ  [LATIN SMALL LETTER L WITH DOT BELOW]
    case '\u{1E39}': // ḹ  [LATIN SMALL LETTER L WITH DOT BELOW AND MACRON]
    case '\u{1E3B}': // ḻ  [LATIN SMALL LETTER L WITH LINE BELOW]
    case '\u{1E3D}': // ḽ  [LATIN SMALL LETTER L WITH CIRCUMFLEX BELOW]
    case '\u{24DB}': // ⓛ  [CIRCLED LATIN SMALL LETTER L]
    case '\u{2C61}': // ⱡ  [LATIN SMALL LETTER L WITH DOUBLE BAR]
    case '\u{A747}': // ꝇ  [LATIN SMALL LETTER BROKEN L]
    case '\u{A749}': // ꝉ  [LATIN SMALL LETTER L WITH HIGH STROKE]
    case '\u{A781}': // ꞁ  [LATIN SMALL LETTER TURNED L]
    case '\u{FF4C}': // ｌ  [FULLWIDTH LATIN SMALL LETTER L]
      return 'l'
    case '\u{01C7}': // Ǉ  [LATIN CAPITAL LETTER LJ]
      return 'LJ'
    case '\u{1EFA}': // Ỻ  [LATIN CAPITAL LETTER MIDDLE-WELSH LL]
      return 'LL'
    case '\u{01C8}': // ǈ  [LATIN CAPITAL LETTER L WITH SMALL LETTER J]
      return 'Lj'
    case '\u{24A7}': // ⒧  [PARENTHESIZED LATIN SMALL LETTER L]
      return '(l)'
    case '\u{01C9}': // ǉ  [LATIN SMALL LETTER LJ]
      return 'lj'
    case '\u{1EFB}': // ỻ  [LATIN SMALL LETTER MIDDLE-WELSH LL]
      return 'll'
    case '\u{02AA}': // ʪ  [LATIN SMALL LETTER LS DIGRAPH]
      return 'ls'
    case '\u{02AB}': // ʫ  [LATIN SMALL LETTER LZ DIGRAPH]
      return 'lz'
    case '\u{019C}': // Ɯ  [LATIN CAPITAL LETTER TURNED M]
    case '\u{1D0D}': // ᴍ  [LATIN LETTER SMALL CAPITAL M]
    case '\u{1E3E}': // Ḿ  [LATIN CAPITAL LETTER M WITH ACUTE]
    case '\u{1E40}': // Ṁ  [LATIN CAPITAL LETTER M WITH DOT ABOVE]
    case '\u{1E42}': // Ṃ  [LATIN CAPITAL LETTER M WITH DOT BELOW]
    case '\u{24C2}': // Ⓜ  [CIRCLED LATIN CAPITAL LETTER M]
    case '\u{2C6E}': // Ɱ  [LATIN CAPITAL LETTER M WITH HOOK]
    case '\u{A7FD}': // ꟽ  [LATIN EPIGRAPHIC LETTER INVERTED M]
    case '\u{A7FF}': // ꟿ  [LATIN EPIGRAPHIC LETTER ARCHAIC M]
    case '\u{FF2D}': // Ｍ  [FULLWIDTH LATIN CAPITAL LETTER M]
      return 'M'
    case '\u{026F}': // ɯ  [LATIN SMALL LETTER TURNED M]
    case '\u{0270}': // ɰ  [LATIN SMALL LETTER TURNED M WITH LONG LEG]
    case '\u{0271}': // ɱ  [LATIN SMALL LETTER M WITH HOOK]
    case '\u{1D6F}': // ᵯ  [LATIN SMALL LETTER M WITH MIDDLE TILDE]
    case '\u{1D86}': // ᶆ  [LATIN SMALL LETTER M WITH PALATAL HOOK]
    case '\u{1E3F}': // ḿ  [LATIN SMALL LETTER M WITH ACUTE]
    case '\u{1E41}': // ṁ  [LATIN SMALL LETTER M WITH DOT ABOVE]
    case '\u{1E43}': // ṃ  [LATIN SMALL LETTER M WITH DOT BELOW]
    case '\u{24DC}': // ⓜ  [CIRCLED LATIN SMALL LETTER M]
    case '\u{FF4D}': // ｍ  [FULLWIDTH LATIN SMALL LETTER M]
      return 'm'
    case '\u{24A8}': // ⒨  [PARENTHESIZED LATIN SMALL LETTER M]
      return '(m)'
    case '\u{00D1}': // Ñ  [LATIN CAPITAL LETTER N WITH TILDE]
    case '\u{0143}': // Ń  [LATIN CAPITAL LETTER N WITH ACUTE]
    case '\u{0145}': // Ņ  [LATIN CAPITAL LETTER N WITH CEDILLA]
    case '\u{0147}': // Ň  [LATIN CAPITAL LETTER N WITH CARON]
    case '\u{014A}': // Ŋ  http://en.wikipedia.org/wiki/Eng_(letter)  [LATIN CAPITAL LETTER ENG]
    case '\u{019D}': // Ɲ  [LATIN CAPITAL LETTER N WITH LEFT HOOK]
    case '\u{01F8}': // Ǹ  [LATIN CAPITAL LETTER N WITH GRAVE]
    case '\u{0220}': // Ƞ  [LATIN CAPITAL LETTER N WITH LONG RIGHT LEG]
    case '\u{0274}': // ɴ  [LATIN LETTER SMALL CAPITAL N]
    case '\u{1D0E}': // ᴎ  [LATIN LETTER SMALL CAPITAL REVERSED N]
    case '\u{1E44}': // Ṅ  [LATIN CAPITAL LETTER N WITH DOT ABOVE]
    case '\u{1E46}': // Ṇ  [LATIN CAPITAL LETTER N WITH DOT BELOW]
    case '\u{1E48}': // Ṉ  [LATIN CAPITAL LETTER N WITH LINE BELOW]
    case '\u{1E4A}': // Ṋ  [LATIN CAPITAL LETTER N WITH CIRCUMFLEX BELOW]
    case '\u{24C3}': // Ⓝ  [CIRCLED LATIN CAPITAL LETTER N]
    case '\u{FF2E}': // Ｎ  [FULLWIDTH LATIN CAPITAL LETTER N]
      return 'N'
    case '\u{00F1}': // ñ  [LATIN SMALL LETTER N WITH TILDE]
    case '\u{0144}': // ń  [LATIN SMALL LETTER N WITH ACUTE]
    case '\u{0146}': // ņ  [LATIN SMALL LETTER N WITH CEDILLA]
    case '\u{0148}': // ň  [LATIN SMALL LETTER N WITH CARON]
    case '\u{0149}': // ŉ  [LATIN SMALL LETTER N PRECEDED BY APOSTROPHE]
    case '\u{014B}': // ŋ  http://en.wikipedia.org/wiki/Eng_(letter)  [LATIN SMALL LETTER ENG]
    case '\u{019E}': // ƞ  [LATIN SMALL LETTER N WITH LONG RIGHT LEG]
    case '\u{01F9}': // ǹ  [LATIN SMALL LETTER N WITH GRAVE]
    case '\u{0235}': // ȵ  [LATIN SMALL LETTER N WITH CURL]
    case '\u{0272}': // ɲ  [LATIN SMALL LETTER N WITH LEFT HOOK]
    case '\u{0273}': // ɳ  [LATIN SMALL LETTER N WITH RETROFLEX HOOK]
    case '\u{1D70}': // ᵰ  [LATIN SMALL LETTER N WITH MIDDLE TILDE]
    case '\u{1D87}': // ᶇ  [LATIN SMALL LETTER N WITH PALATAL HOOK]
    case '\u{1E45}': // ṅ  [LATIN SMALL LETTER N WITH DOT ABOVE]
    case '\u{1E47}': // ṇ  [LATIN SMALL LETTER N WITH DOT BELOW]
    case '\u{1E49}': // ṉ  [LATIN SMALL LETTER N WITH LINE BELOW]
    case '\u{1E4B}': // ṋ  [LATIN SMALL LETTER N WITH CIRCUMFLEX BELOW]
    case '\u{207F}': // ⁿ  [SUPERSCRIPT LATIN SMALL LETTER N]
    case '\u{24DD}': // ⓝ  [CIRCLED LATIN SMALL LETTER N]
    case '\u{FF4E}': // ｎ  [FULLWIDTH LATIN SMALL LETTER N]
      return 'n'
    case '\u{01CA}': // Ǌ  [LATIN CAPITAL LETTER NJ]
      return 'NJ'
    case '\u{01CB}': // ǋ  [LATIN CAPITAL LETTER N WITH SMALL LETTER J]
      return 'Nj'
    case '\u{24A9}': // ⒩  [PARENTHESIZED LATIN SMALL LETTER N]
      return '(n)'
    case '\u{01CC}': // ǌ  [LATIN SMALL LETTER NJ]
      return 'nj'
    case '\u{00D2}': // Ò  [LATIN CAPITAL LETTER O WITH GRAVE]
    case '\u{00D3}': // Ó  [LATIN CAPITAL LETTER O WITH ACUTE]
    case '\u{00D4}': // Ô  [LATIN CAPITAL LETTER O WITH CIRCUMFLEX]
    case '\u{00D5}': // Õ  [LATIN CAPITAL LETTER O WITH TILDE]
    case '\u{00D6}': // Ö  [LATIN CAPITAL LETTER O WITH DIAERESIS]
    case '\u{00D8}': // Ø  [LATIN CAPITAL LETTER O WITH STROKE]
    case '\u{014C}': // Ō  [LATIN CAPITAL LETTER O WITH MACRON]
    case '\u{014E}': // Ŏ  [LATIN CAPITAL LETTER O WITH BREVE]
    case '\u{0150}': // Ő  [LATIN CAPITAL LETTER O WITH DOUBLE ACUTE]
    case '\u{0186}': // Ɔ  [LATIN CAPITAL LETTER OPEN O]
    case '\u{019F}': // Ɵ  [LATIN CAPITAL LETTER O WITH MIDDLE TILDE]
    case '\u{01A0}': // Ơ  [LATIN CAPITAL LETTER O WITH HORN]
    case '\u{01D1}': // Ǒ  [LATIN CAPITAL LETTER O WITH CARON]
    case '\u{01EA}': // Ǫ  [LATIN CAPITAL LETTER O WITH OGONEK]
    case '\u{01EC}': // Ǭ  [LATIN CAPITAL LETTER O WITH OGONEK AND MACRON]
    case '\u{01FE}': // Ǿ  [LATIN CAPITAL LETTER O WITH STROKE AND ACUTE]
    case '\u{020C}': // Ȍ  [LATIN CAPITAL LETTER O WITH DOUBLE GRAVE]
    case '\u{020E}': // Ȏ  [LATIN CAPITAL LETTER O WITH INVERTED BREVE]
    case '\u{022A}': // Ȫ  [LATIN CAPITAL LETTER O WITH DIAERESIS AND MACRON]
    case '\u{022C}': // Ȭ  [LATIN CAPITAL LETTER O WITH TILDE AND MACRON]
    case '\u{022E}': // Ȯ  [LATIN CAPITAL LETTER O WITH DOT ABOVE]
    case '\u{0230}': // Ȱ  [LATIN CAPITAL LETTER O WITH DOT ABOVE AND MACRON]
    case '\u{1D0F}': // ᴏ  [LATIN LETTER SMALL CAPITAL O]
    case '\u{1D10}': // ᴐ  [LATIN LETTER SMALL CAPITAL OPEN O]
    case '\u{1E4C}': // Ṍ  [LATIN CAPITAL LETTER O WITH TILDE AND ACUTE]
    case '\u{1E4E}': // Ṏ  [LATIN CAPITAL LETTER O WITH TILDE AND DIAERESIS]
    case '\u{1E50}': // Ṑ  [LATIN CAPITAL LETTER O WITH MACRON AND GRAVE]
    case '\u{1E52}': // Ṓ  [LATIN CAPITAL LETTER O WITH MACRON AND ACUTE]
    case '\u{1ECC}': // Ọ  [LATIN CAPITAL LETTER O WITH DOT BELOW]
    case '\u{1ECE}': // Ỏ  [LATIN CAPITAL LETTER O WITH HOOK ABOVE]
    case '\u{1ED0}': // Ố  [LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND ACUTE]
    case '\u{1ED2}': // Ồ  [LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND GRAVE]
    case '\u{1ED4}': // Ổ  [LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE]
    case '\u{1ED6}': // Ỗ  [LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND TILDE]
    case '\u{1ED8}': // Ộ  [LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND DOT BELOW]
    case '\u{1EDA}': // Ớ  [LATIN CAPITAL LETTER O WITH HORN AND ACUTE]
    case '\u{1EDC}': // Ờ  [LATIN CAPITAL LETTER O WITH HORN AND GRAVE]
    case '\u{1EDE}': // Ở  [LATIN CAPITAL LETTER O WITH HORN AND HOOK ABOVE]
    case '\u{1EE0}': // Ỡ  [LATIN CAPITAL LETTER O WITH HORN AND TILDE]
    case '\u{1EE2}': // Ợ  [LATIN CAPITAL LETTER O WITH HORN AND DOT BELOW]
    case '\u{24C4}': // Ⓞ  [CIRCLED LATIN CAPITAL LETTER O]
    case '\u{A74A}': // Ꝋ  [LATIN CAPITAL LETTER O WITH LONG STROKE OVERLAY]
    case '\u{A74C}': // Ꝍ  [LATIN CAPITAL LETTER O WITH LOOP]
    case '\u{FF2F}': // Ｏ  [FULLWIDTH LATIN CAPITAL LETTER O]
      return 'O'
    case '\u{00F2}': // ò  [LATIN SMALL LETTER O WITH GRAVE]
    case '\u{00F3}': // ó  [LATIN SMALL LETTER O WITH ACUTE]
    case '\u{00F4}': // ô  [LATIN SMALL LETTER O WITH CIRCUMFLEX]
    case '\u{00F5}': // õ  [LATIN SMALL LETTER O WITH TILDE]
    case '\u{00F6}': // ö  [LATIN SMALL LETTER O WITH DIAERESIS]
    case '\u{00F8}': // ø  [LATIN SMALL LETTER O WITH STROKE]
    case '\u{014D}': // ō  [LATIN SMALL LETTER O WITH MACRON]
    case '\u{014F}': // ŏ  [LATIN SMALL LETTER O WITH BREVE]
    case '\u{0151}': // ő  [LATIN SMALL LETTER O WITH DOUBLE ACUTE]
    case '\u{01A1}': // ơ  [LATIN SMALL LETTER O WITH HORN]
    case '\u{01D2}': // ǒ  [LATIN SMALL LETTER O WITH CARON]
    case '\u{01EB}': // ǫ  [LATIN SMALL LETTER O WITH OGONEK]
    case '\u{01ED}': // ǭ  [LATIN SMALL LETTER O WITH OGONEK AND MACRON]
    case '\u{01FF}': // ǿ  [LATIN SMALL LETTER O WITH STROKE AND ACUTE]
    case '\u{020D}': // ȍ  [LATIN SMALL LETTER O WITH DOUBLE GRAVE]
    case '\u{020F}': // ȏ  [LATIN SMALL LETTER O WITH INVERTED BREVE]
    case '\u{022B}': // ȫ  [LATIN SMALL LETTER O WITH DIAERESIS AND MACRON]
    case '\u{022D}': // ȭ  [LATIN SMALL LETTER O WITH TILDE AND MACRON]
    case '\u{022F}': // ȯ  [LATIN SMALL LETTER O WITH DOT ABOVE]
    case '\u{0231}': // ȱ  [LATIN SMALL LETTER O WITH DOT ABOVE AND MACRON]
    case '\u{0254}': // ɔ  [LATIN SMALL LETTER OPEN O]
    case '\u{0275}': // ɵ  [LATIN SMALL LETTER BARRED O]
    case '\u{1D16}': // ᴖ  [LATIN SMALL LETTER TOP HALF O]
    case '\u{1D17}': // ᴗ  [LATIN SMALL LETTER BOTTOM HALF O]
    case '\u{1D97}': // ᶗ  [LATIN SMALL LETTER OPEN O WITH RETROFLEX HOOK]
    case '\u{1E4D}': // ṍ  [LATIN SMALL LETTER O WITH TILDE AND ACUTE]
    case '\u{1E4F}': // ṏ  [LATIN SMALL LETTER O WITH TILDE AND DIAERESIS]
    case '\u{1E51}': // ṑ  [LATIN SMALL LETTER O WITH MACRON AND GRAVE]
    case '\u{1E53}': // ṓ  [LATIN SMALL LETTER O WITH MACRON AND ACUTE]
    case '\u{1ECD}': // ọ  [LATIN SMALL LETTER O WITH DOT BELOW]
    case '\u{1ECF}': // ỏ  [LATIN SMALL LETTER O WITH HOOK ABOVE]
    case '\u{1ED1}': // ố  [LATIN SMALL LETTER O WITH CIRCUMFLEX AND ACUTE]
    case '\u{1ED3}': // ồ  [LATIN SMALL LETTER O WITH CIRCUMFLEX AND GRAVE]
    case '\u{1ED5}': // ổ  [LATIN SMALL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE]
    case '\u{1ED7}': // ỗ  [LATIN SMALL LETTER O WITH CIRCUMFLEX AND TILDE]
    case '\u{1ED9}': // ộ  [LATIN SMALL LETTER O WITH CIRCUMFLEX AND DOT BELOW]
    case '\u{1EDB}': // ớ  [LATIN SMALL LETTER O WITH HORN AND ACUTE]
    case '\u{1EDD}': // ờ  [LATIN SMALL LETTER O WITH HORN AND GRAVE]
    case '\u{1EDF}': // ở  [LATIN SMALL LETTER O WITH HORN AND HOOK ABOVE]
    case '\u{1EE1}': // ỡ  [LATIN SMALL LETTER O WITH HORN AND TILDE]
    case '\u{1EE3}': // ợ  [LATIN SMALL LETTER O WITH HORN AND DOT BELOW]
    case '\u{2092}': // ₒ  [LATIN SUBSCRIPT SMALL LETTER O]
    case '\u{24DE}': // ⓞ  [CIRCLED LATIN SMALL LETTER O]
    case '\u{2C7A}': // ⱺ  [LATIN SMALL LETTER O WITH LOW RING INSIDE]
    case '\u{A74B}': // ꝋ  [LATIN SMALL LETTER O WITH LONG STROKE OVERLAY]
    case '\u{A74D}': // ꝍ  [LATIN SMALL LETTER O WITH LOOP]
    case '\u{FF4F}': // ｏ  [FULLWIDTH LATIN SMALL LETTER O]
      return 'o'
    case '\u{0152}': // Œ  [LATIN CAPITAL LIGATURE OE]
    case '\u{0276}': // ɶ  [LATIN LETTER SMALL CAPITAL OE]
      return 'OE'
    case '\u{A74E}': // Ꝏ  [LATIN CAPITAL LETTER OO]
      return 'OO'
    case '\u{0222}': // Ȣ  http://en.wikipedia.org/wiki/OU  [LATIN CAPITAL LETTER OU]
    case '\u{1D15}': // ᴕ  [LATIN LETTER SMALL CAPITAL OU]
      return 'OU'
    case '\u{24AA}': // ⒪  [PARENTHESIZED LATIN SMALL LETTER O]
      return '(o)'
    case '\u{0153}': // œ  [LATIN SMALL LIGATURE OE]
    case '\u{1D14}': // ᴔ  [LATIN SMALL LETTER TURNED OE]
      return 'oe'
    case '\u{A74F}': // ꝏ  [LATIN SMALL LETTER OO]
      return 'oo'
    case '\u{0223}': // ȣ  http://en.wikipedia.org/wiki/OU  [LATIN SMALL LETTER OU]
      return 'ou'
    case '\u{01A4}': // Ƥ  [LATIN CAPITAL LETTER P WITH HOOK]
    case '\u{1D18}': // ᴘ  [LATIN LETTER SMALL CAPITAL P]
    case '\u{1E54}': // Ṕ  [LATIN CAPITAL LETTER P WITH ACUTE]
    case '\u{1E56}': // Ṗ  [LATIN CAPITAL LETTER P WITH DOT ABOVE]
    case '\u{24C5}': // Ⓟ  [CIRCLED LATIN CAPITAL LETTER P]
    case '\u{2C63}': // Ᵽ  [LATIN CAPITAL LETTER P WITH STROKE]
    case '\u{A750}': // Ꝑ  [LATIN CAPITAL LETTER P WITH STROKE THROUGH DESCENDER]
    case '\u{A752}': // Ꝓ  [LATIN CAPITAL LETTER P WITH FLOURISH]
    case '\u{A754}': // Ꝕ  [LATIN CAPITAL LETTER P WITH SQUIRREL TAIL]
    case '\u{FF30}': // Ｐ  [FULLWIDTH LATIN CAPITAL LETTER P]
      return 'P'
    case '\u{01A5}': // ƥ  [LATIN SMALL LETTER P WITH HOOK]
    case '\u{1D71}': // ᵱ  [LATIN SMALL LETTER P WITH MIDDLE TILDE]
    case '\u{1D7D}': // ᵽ  [LATIN SMALL LETTER P WITH STROKE]
    case '\u{1D88}': // ᶈ  [LATIN SMALL LETTER P WITH PALATAL HOOK]
    case '\u{1E55}': // ṕ  [LATIN SMALL LETTER P WITH ACUTE]
    case '\u{1E57}': // ṗ  [LATIN SMALL LETTER P WITH DOT ABOVE]
    case '\u{24DF}': // ⓟ  [CIRCLED LATIN SMALL LETTER P]
    case '\u{A751}': // ꝑ  [LATIN SMALL LETTER P WITH STROKE THROUGH DESCENDER]
    case '\u{A753}': // ꝓ  [LATIN SMALL LETTER P WITH FLOURISH]
    case '\u{A755}': // ꝕ  [LATIN SMALL LETTER P WITH SQUIRREL TAIL]
    case '\u{A7FC}': // ꟼ  [LATIN EPIGRAPHIC LETTER REVERSED P]
    case '\u{FF50}': // ｐ  [FULLWIDTH LATIN SMALL LETTER P]
      return 'p'
    case '\u{24AB}': // ⒫  [PARENTHESIZED LATIN SMALL LETTER P]
      return '(p)'
    case '\u{024A}': // Ɋ  [LATIN CAPITAL LETTER SMALL Q WITH HOOK TAIL]
    case '\u{24C6}': // Ⓠ  [CIRCLED LATIN CAPITAL LETTER Q]
    case '\u{A756}': // Ꝗ  [LATIN CAPITAL LETTER Q WITH STROKE THROUGH DESCENDER]
    case '\u{A758}': // Ꝙ  [LATIN CAPITAL LETTER Q WITH DIAGONAL STROKE]
    case '\u{FF31}': // Ｑ  [FULLWIDTH LATIN CAPITAL LETTER Q]
      return 'Q'
    case '\u{0138}': // ĸ  http://en.wikipedia.org/wiki/Kra_(letter)  [LATIN SMALL LETTER KRA]
    case '\u{024B}': // ɋ  [LATIN SMALL LETTER Q WITH HOOK TAIL]
    case '\u{02A0}': // ʠ  [LATIN SMALL LETTER Q WITH HOOK]
    case '\u{24E0}': // ⓠ  [CIRCLED LATIN SMALL LETTER Q]
    case '\u{A757}': // ꝗ  [LATIN SMALL LETTER Q WITH STROKE THROUGH DESCENDER]
    case '\u{A759}': // ꝙ  [LATIN SMALL LETTER Q WITH DIAGONAL STROKE]
    case '\u{FF51}': // ｑ  [FULLWIDTH LATIN SMALL LETTER Q]
      return 'q'
    case '\u{24AC}': // ⒬  [PARENTHESIZED LATIN SMALL LETTER Q]
      return '(q)'
    case '\u{0239}': // ȹ  [LATIN SMALL LETTER QP DIGRAPH]
      return 'qp'
    case '\u{0154}': // Ŕ  [LATIN CAPITAL LETTER R WITH ACUTE]
    case '\u{0156}': // Ŗ  [LATIN CAPITAL LETTER R WITH CEDILLA]
    case '\u{0158}': // Ř  [LATIN CAPITAL LETTER R WITH CARON]
    case '\u{0210}': // Ȓ  [LATIN CAPITAL LETTER R WITH DOUBLE GRAVE]
    case '\u{0212}': // Ȓ  [LATIN CAPITAL LETTER R WITH INVERTED BREVE]
    case '\u{024C}': // Ɍ  [LATIN CAPITAL LETTER R WITH STROKE]
    case '\u{0280}': // ʀ  [LATIN LETTER SMALL CAPITAL R]
    case '\u{0281}': // ʁ  [LATIN LETTER SMALL CAPITAL INVERTED R]
    case '\u{1D19}': // ᴙ  [LATIN LETTER SMALL CAPITAL REVERSED R]
    case '\u{1D1A}': // ᴚ  [LATIN LETTER SMALL CAPITAL TURNED R]
    case '\u{1E58}': // Ṙ  [LATIN CAPITAL LETTER R WITH DOT ABOVE]
    case '\u{1E5A}': // Ṛ  [LATIN CAPITAL LETTER R WITH DOT BELOW]
    case '\u{1E5C}': // Ṝ  [LATIN CAPITAL LETTER R WITH DOT BELOW AND MACRON]
    case '\u{1E5E}': // Ṟ  [LATIN CAPITAL LETTER R WITH LINE BELOW]
    case '\u{24C7}': // Ⓡ  [CIRCLED LATIN CAPITAL LETTER R]
    case '\u{2C64}': // Ɽ  [LATIN CAPITAL LETTER R WITH TAIL]
    case '\u{A75A}': // Ꝛ  [LATIN CAPITAL LETTER R ROTUNDA]
    case '\u{A782}': // Ꞃ  [LATIN CAPITAL LETTER INSULAR R]
    case '\u{FF32}': // Ｒ  [FULLWIDTH LATIN CAPITAL LETTER R]
      return 'R'
    case '\u{0155}': // ŕ  [LATIN SMALL LETTER R WITH ACUTE]
    case '\u{0157}': // ŗ  [LATIN SMALL LETTER R WITH CEDILLA]
    case '\u{0159}': // ř  [LATIN SMALL LETTER R WITH CARON]
    case '\u{0211}': // ȑ  [LATIN SMALL LETTER R WITH DOUBLE GRAVE]
    case '\u{0213}': // ȓ  [LATIN SMALL LETTER R WITH INVERTED BREVE]
    case '\u{024D}': // ɍ  [LATIN SMALL LETTER R WITH STROKE]
    case '\u{027C}': // ɼ  [LATIN SMALL LETTER R WITH LONG LEG]
    case '\u{027D}': // ɽ  [LATIN SMALL LETTER R WITH TAIL]
    case '\u{027E}': // ɾ  [LATIN SMALL LETTER R WITH FISHHOOK]
    case '\u{027F}': // ɿ  [LATIN SMALL LETTER REVERSED R WITH FISHHOOK]
    case '\u{1D63}': // ᵣ  [LATIN SUBSCRIPT SMALL LETTER R]
    case '\u{1D72}': // ᵲ  [LATIN SMALL LETTER R WITH MIDDLE TILDE]
    case '\u{1D73}': // ᵳ  [LATIN SMALL LETTER R WITH FISHHOOK AND MIDDLE TILDE]
    case '\u{1D89}': // ᶉ  [LATIN SMALL LETTER R WITH PALATAL HOOK]
    case '\u{1E59}': // ṙ  [LATIN SMALL LETTER R WITH DOT ABOVE]
    case '\u{1E5B}': // ṛ  [LATIN SMALL LETTER R WITH DOT BELOW]
    case '\u{1E5D}': // ṝ  [LATIN SMALL LETTER R WITH DOT BELOW AND MACRON]
    case '\u{1E5F}': // ṟ  [LATIN SMALL LETTER R WITH LINE BELOW]
    case '\u{24E1}': // ⓡ  [CIRCLED LATIN SMALL LETTER R]
    case '\u{A75B}': // ꝛ  [LATIN SMALL LETTER R ROTUNDA]
    case '\u{A783}': // ꞃ  [LATIN SMALL LETTER INSULAR R]
    case '\u{FF52}': // ｒ  [FULLWIDTH LATIN SMALL LETTER R]
      return 'r'
    case '\u{24AD}': // ⒭  [PARENTHESIZED LATIN SMALL LETTER R]
      return '(r)'
    case '\u{015A}': // Ś  [LATIN CAPITAL LETTER S WITH ACUTE]
    case '\u{015C}': // Ŝ  [LATIN CAPITAL LETTER S WITH CIRCUMFLEX]
    case '\u{015E}': // Ş  [LATIN CAPITAL LETTER S WITH CEDILLA]
    case '\u{0160}': // Š  [LATIN CAPITAL LETTER S WITH CARON]
    case '\u{0218}': // Ș  [LATIN CAPITAL LETTER S WITH COMMA BELOW]
    case '\u{1E60}': // Ṡ  [LATIN CAPITAL LETTER S WITH DOT ABOVE]
    case '\u{1E62}': // Ṣ  [LATIN CAPITAL LETTER S WITH DOT BELOW]
    case '\u{1E64}': // Ṥ  [LATIN CAPITAL LETTER S WITH ACUTE AND DOT ABOVE]
    case '\u{1E66}': // Ṧ  [LATIN CAPITAL LETTER S WITH CARON AND DOT ABOVE]
    case '\u{1E68}': // Ṩ  [LATIN CAPITAL LETTER S WITH DOT BELOW AND DOT ABOVE]
    case '\u{24C8}': // Ⓢ  [CIRCLED LATIN CAPITAL LETTER S]
    case '\u{A731}': // ꜱ  [LATIN LETTER SMALL CAPITAL S]
    case '\u{A785}': // ꞅ  [LATIN SMALL LETTER INSULAR S]
    case '\u{FF33}': // Ｓ  [FULLWIDTH LATIN CAPITAL LETTER S]
      return 'S'
    case '\u{015B}': // ś  [LATIN SMALL LETTER S WITH ACUTE]
    case '\u{015D}': // ŝ  [LATIN SMALL LETTER S WITH CIRCUMFLEX]
    case '\u{015F}': // ş  [LATIN SMALL LETTER S WITH CEDILLA]
    case '\u{0161}': // š  [LATIN SMALL LETTER S WITH CARON]
    case '\u{017F}': // ſ  http://en.wikipedia.org/wiki/Long_S  [LATIN SMALL LETTER LONG S]
    case '\u{0219}': // ș  [LATIN SMALL LETTER S WITH COMMA BELOW]
    case '\u{023F}': // ȿ  [LATIN SMALL LETTER S WITH SWASH TAIL]
    case '\u{0282}': // ʂ  [LATIN SMALL LETTER S WITH HOOK]
    case '\u{1D74}': // ᵴ  [LATIN SMALL LETTER S WITH MIDDLE TILDE]
    case '\u{1D8A}': // ᶊ  [LATIN SMALL LETTER S WITH PALATAL HOOK]
    case '\u{1E61}': // ṡ  [LATIN SMALL LETTER S WITH DOT ABOVE]
    case '\u{1E63}': // ṣ  [LATIN SMALL LETTER S WITH DOT BELOW]
    case '\u{1E65}': // ṥ  [LATIN SMALL LETTER S WITH ACUTE AND DOT ABOVE]
    case '\u{1E67}': // ṧ  [LATIN SMALL LETTER S WITH CARON AND DOT ABOVE]
    case '\u{1E69}': // ṩ  [LATIN SMALL LETTER S WITH DOT BELOW AND DOT ABOVE]
    case '\u{1E9C}': // ẜ  [LATIN SMALL LETTER LONG S WITH DIAGONAL STROKE]
    case '\u{1E9D}': // ẝ  [LATIN SMALL LETTER LONG S WITH HIGH STROKE]
    case '\u{24E2}': // ⓢ  [CIRCLED LATIN SMALL LETTER S]
    case '\u{A784}': // Ꞅ  [LATIN CAPITAL LETTER INSULAR S]
    case '\u{FF53}': // ｓ  [FULLWIDTH LATIN SMALL LETTER S]
      return 's'
    case '\u{1E9E}': // ẞ  [LATIN CAPITAL LETTER SHARP S]
      return 'SS'
    case '\u{24AE}': // ⒮  [PARENTHESIZED LATIN SMALL LETTER S]
      return '(s)'
    case '\u{00DF}': // ß  [LATIN SMALL LETTER SHARP S]
      return 'ss'
    case '\u{FB06}': // ﬆ  [LATIN SMALL LIGATURE ST]
      return 'st'
    case '\u{0162}': // Ţ  [LATIN CAPITAL LETTER T WITH CEDILLA]
    case '\u{0164}': // Ť  [LATIN CAPITAL LETTER T WITH CARON]
    case '\u{0166}': // Ŧ  [LATIN CAPITAL LETTER T WITH STROKE]
    case '\u{01AC}': // Ƭ  [LATIN CAPITAL LETTER T WITH HOOK]
    case '\u{01AE}': // Ʈ  [LATIN CAPITAL LETTER T WITH RETROFLEX HOOK]
    case '\u{021A}': // Ț  [LATIN CAPITAL LETTER T WITH COMMA BELOW]
    case '\u{023E}': // Ⱦ  [LATIN CAPITAL LETTER T WITH DIAGONAL STROKE]
    case '\u{1D1B}': // ᴛ  [LATIN LETTER SMALL CAPITAL T]
    case '\u{1E6A}': // Ṫ  [LATIN CAPITAL LETTER T WITH DOT ABOVE]
    case '\u{1E6C}': // Ṭ  [LATIN CAPITAL LETTER T WITH DOT BELOW]
    case '\u{1E6E}': // Ṯ  [LATIN CAPITAL LETTER T WITH LINE BELOW]
    case '\u{1E70}': // Ṱ  [LATIN CAPITAL LETTER T WITH CIRCUMFLEX BELOW]
    case '\u{24C9}': // Ⓣ  [CIRCLED LATIN CAPITAL LETTER T]
    case '\u{A786}': // Ꞇ  [LATIN CAPITAL LETTER INSULAR T]
    case '\u{FF34}': // Ｔ  [FULLWIDTH LATIN CAPITAL LETTER T]
      return 'T'
    case '\u{0163}': // ţ  [LATIN SMALL LETTER T WITH CEDILLA]
    case '\u{0165}': // ť  [LATIN SMALL LETTER T WITH CARON]
    case '\u{0167}': // ŧ  [LATIN SMALL LETTER T WITH STROKE]
    case '\u{01AB}': // ƫ  [LATIN SMALL LETTER T WITH PALATAL HOOK]
    case '\u{01AD}': // ƭ  [LATIN SMALL LETTER T WITH HOOK]
    case '\u{021B}': // ț  [LATIN SMALL LETTER T WITH COMMA BELOW]
    case '\u{0236}': // ȶ  [LATIN SMALL LETTER T WITH CURL]
    case '\u{0287}': // ʇ  [LATIN SMALL LETTER TURNED T]
    case '\u{0288}': // ʈ  [LATIN SMALL LETTER T WITH RETROFLEX HOOK]
    case '\u{1D75}': // ᵵ  [LATIN SMALL LETTER T WITH MIDDLE TILDE]
    case '\u{1E6B}': // ṫ  [LATIN SMALL LETTER T WITH DOT ABOVE]
    case '\u{1E6D}': // ṭ  [LATIN SMALL LETTER T WITH DOT BELOW]
    case '\u{1E6F}': // ṯ  [LATIN SMALL LETTER T WITH LINE BELOW]
    case '\u{1E71}': // ṱ  [LATIN SMALL LETTER T WITH CIRCUMFLEX BELOW]
    case '\u{1E97}': // ẗ  [LATIN SMALL LETTER T WITH DIAERESIS]
    case '\u{24E3}': // ⓣ  [CIRCLED LATIN SMALL LETTER T]
    case '\u{2C66}': // ⱦ  [LATIN SMALL LETTER T WITH DIAGONAL STROKE]
    case '\u{FF54}': // ｔ  [FULLWIDTH LATIN SMALL LETTER T]
      return 't'
    case '\u{00DE}': // Þ  [LATIN CAPITAL LETTER THORN]
    case '\u{A766}': // Ꝧ  [LATIN CAPITAL LETTER THORN WITH STROKE THROUGH DESCENDER]
      return 'TH'
    case '\u{A728}': // Ꜩ  [LATIN CAPITAL LETTER TZ]
      return 'TZ'
    case '\u{24AF}': // ⒯  [PARENTHESIZED LATIN SMALL LETTER T]
      return '(t)'
    case '\u{02A8}': // ʨ  [LATIN SMALL LETTER TC DIGRAPH WITH CURL]
      return 'tc'
    case '\u{00FE}': // þ  [LATIN SMALL LETTER THORN]
    case '\u{1D7A}': // ᵺ  [LATIN SMALL LETTER TH WITH STRIKETHROUGH]
    case '\u{A767}': // ꝧ  [LATIN SMALL LETTER THORN WITH STROKE THROUGH DESCENDER]
      return 'th'
    case '\u{02A6}': // ʦ  [LATIN SMALL LETTER TS DIGRAPH]
      return 'ts'
    case '\u{A729}': // ꜩ  [LATIN SMALL LETTER TZ]
      return 'tz'
    case '\u{00D9}': // Ù  [LATIN CAPITAL LETTER U WITH GRAVE]
    case '\u{00DA}': // Ú  [LATIN CAPITAL LETTER U WITH ACUTE]
    case '\u{00DB}': // Û  [LATIN CAPITAL LETTER U WITH CIRCUMFLEX]
    case '\u{00DC}': // Ü  [LATIN CAPITAL LETTER U WITH DIAERESIS]
    case '\u{0168}': // Ũ  [LATIN CAPITAL LETTER U WITH TILDE]
    case '\u{016A}': // Ū  [LATIN CAPITAL LETTER U WITH MACRON]
    case '\u{016C}': // Ŭ  [LATIN CAPITAL LETTER U WITH BREVE]
    case '\u{016E}': // Ů  [LATIN CAPITAL LETTER U WITH RING ABOVE]
    case '\u{0170}': // Ű  [LATIN CAPITAL LETTER U WITH DOUBLE ACUTE]
    case '\u{0172}': // Ų  [LATIN CAPITAL LETTER U WITH OGONEK]
    case '\u{01AF}': // Ư  [LATIN CAPITAL LETTER U WITH HORN]
    case '\u{01D3}': // Ǔ  [LATIN CAPITAL LETTER U WITH CARON]
    case '\u{01D5}': // Ǖ  [LATIN CAPITAL LETTER U WITH DIAERESIS AND MACRON]
    case '\u{01D7}': // Ǘ  [LATIN CAPITAL LETTER U WITH DIAERESIS AND ACUTE]
    case '\u{01D9}': // Ǚ  [LATIN CAPITAL LETTER U WITH DIAERESIS AND CARON]
    case '\u{01DB}': // Ǜ  [LATIN CAPITAL LETTER U WITH DIAERESIS AND GRAVE]
    case '\u{0214}': // Ȕ  [LATIN CAPITAL LETTER U WITH DOUBLE GRAVE]
    case '\u{0216}': // Ȗ  [LATIN CAPITAL LETTER U WITH INVERTED BREVE]
    case '\u{0244}': // Ʉ  [LATIN CAPITAL LETTER U BAR]
    case '\u{1D1C}': // ᴜ  [LATIN LETTER SMALL CAPITAL U]
    case '\u{1D7E}': // ᵾ  [LATIN SMALL CAPITAL LETTER U WITH STROKE]
    case '\u{1E72}': // Ṳ  [LATIN CAPITAL LETTER U WITH DIAERESIS BELOW]
    case '\u{1E74}': // Ṵ  [LATIN CAPITAL LETTER U WITH TILDE BELOW]
    case '\u{1E76}': // Ṷ  [LATIN CAPITAL LETTER U WITH CIRCUMFLEX BELOW]
    case '\u{1E78}': // Ṹ  [LATIN CAPITAL LETTER U WITH TILDE AND ACUTE]
    case '\u{1E7A}': // Ṻ  [LATIN CAPITAL LETTER U WITH MACRON AND DIAERESIS]
    case '\u{1EE4}': // Ụ  [LATIN CAPITAL LETTER U WITH DOT BELOW]
    case '\u{1EE6}': // Ủ  [LATIN CAPITAL LETTER U WITH HOOK ABOVE]
    case '\u{1EE8}': // Ứ  [LATIN CAPITAL LETTER U WITH HORN AND ACUTE]
    case '\u{1EEA}': // Ừ  [LATIN CAPITAL LETTER U WITH HORN AND GRAVE]
    case '\u{1EEC}': // Ử  [LATIN CAPITAL LETTER U WITH HORN AND HOOK ABOVE]
    case '\u{1EEE}': // Ữ  [LATIN CAPITAL LETTER U WITH HORN AND TILDE]
    case '\u{1EF0}': // Ự  [LATIN CAPITAL LETTER U WITH HORN AND DOT BELOW]
    case '\u{24CA}': // Ⓤ  [CIRCLED LATIN CAPITAL LETTER U]
    case '\u{FF35}': // Ｕ  [FULLWIDTH LATIN CAPITAL LETTER U]
      return 'U'
    case '\u{00F9}': // ù  [LATIN SMALL LETTER U WITH GRAVE]
    case '\u{00FA}': // ú  [LATIN SMALL LETTER U WITH ACUTE]
    case '\u{00FB}': // û  [LATIN SMALL LETTER U WITH CIRCUMFLEX]
    case '\u{00FC}': // ü  [LATIN SMALL LETTER U WITH DIAERESIS]
    case '\u{0169}': // ũ  [LATIN SMALL LETTER U WITH TILDE]
    case '\u{016B}': // ū  [LATIN SMALL LETTER U WITH MACRON]
    case '\u{016D}': // ŭ  [LATIN SMALL LETTER U WITH BREVE]
    case '\u{016F}': // ů  [LATIN SMALL LETTER U WITH RING ABOVE]
    case '\u{0171}': // ű  [LATIN SMALL LETTER U WITH DOUBLE ACUTE]
    case '\u{0173}': // ų  [LATIN SMALL LETTER U WITH OGONEK]
    case '\u{01B0}': // ư  [LATIN SMALL LETTER U WITH HORN]
    case '\u{01D4}': // ǔ  [LATIN SMALL LETTER U WITH CARON]
    case '\u{01D6}': // ǖ  [LATIN SMALL LETTER U WITH DIAERESIS AND MACRON]
    case '\u{01D8}': // ǘ  [LATIN SMALL LETTER U WITH DIAERESIS AND ACUTE]
    case '\u{01DA}': // ǚ  [LATIN SMALL LETTER U WITH DIAERESIS AND CARON]
    case '\u{01DC}': // ǜ  [LATIN SMALL LETTER U WITH DIAERESIS AND GRAVE]
    case '\u{0215}': // ȕ  [LATIN SMALL LETTER U WITH DOUBLE GRAVE]
    case '\u{0217}': // ȗ  [LATIN SMALL LETTER U WITH INVERTED BREVE]
    case '\u{0289}': // ʉ  [LATIN SMALL LETTER U BAR]
    case '\u{1D64}': // ᵤ  [LATIN SUBSCRIPT SMALL LETTER U]
    case '\u{1D99}': // ᶙ  [LATIN SMALL LETTER U WITH RETROFLEX HOOK]
    case '\u{1E73}': // ṳ  [LATIN SMALL LETTER U WITH DIAERESIS BELOW]
    case '\u{1E75}': // ṵ  [LATIN SMALL LETTER U WITH TILDE BELOW]
    case '\u{1E77}': // ṷ  [LATIN SMALL LETTER U WITH CIRCUMFLEX BELOW]
    case '\u{1E79}': // ṹ  [LATIN SMALL LETTER U WITH TILDE AND ACUTE]
    case '\u{1E7B}': // ṻ  [LATIN SMALL LETTER U WITH MACRON AND DIAERESIS]
    case '\u{1EE5}': // ụ  [LATIN SMALL LETTER U WITH DOT BELOW]
    case '\u{1EE7}': // ủ  [LATIN SMALL LETTER U WITH HOOK ABOVE]
    case '\u{1EE9}': // ứ  [LATIN SMALL LETTER U WITH HORN AND ACUTE]
    case '\u{1EEB}': // ừ  [LATIN SMALL LETTER U WITH HORN AND GRAVE]
    case '\u{1EED}': // ử  [LATIN SMALL LETTER U WITH HORN AND HOOK ABOVE]
    case '\u{1EEF}': // ữ  [LATIN SMALL LETTER U WITH HORN AND TILDE]
    case '\u{1EF1}': // ự  [LATIN SMALL LETTER U WITH HORN AND DOT BELOW]
    case '\u{24E4}': // ⓤ  [CIRCLED LATIN SMALL LETTER U]
    case '\u{FF55}': // ｕ  [FULLWIDTH LATIN SMALL LETTER U]
      return 'u'
    case '\u{24B0}': // ⒰  [PARENTHESIZED LATIN SMALL LETTER U]
      return '(u)'
    case '\u{1D6B}': // ᵫ  [LATIN SMALL LETTER UE]
      return 'ue'
    case '\u{01B2}': // Ʋ  [LATIN CAPITAL LETTER V WITH HOOK]
    case '\u{0245}': // Ʌ  [LATIN CAPITAL LETTER TURNED V]
    case '\u{1D20}': // ᴠ  [LATIN LETTER SMALL CAPITAL V]
    case '\u{1E7C}': // Ṽ  [LATIN CAPITAL LETTER V WITH TILDE]
    case '\u{1E7E}': // Ṿ  [LATIN CAPITAL LETTER V WITH DOT BELOW]
    case '\u{1EFC}': // Ỽ  [LATIN CAPITAL LETTER MIDDLE-WELSH V]
    case '\u{24CB}': // Ⓥ  [CIRCLED LATIN CAPITAL LETTER V]
    case '\u{A75E}': // Ꝟ  [LATIN CAPITAL LETTER V WITH DIAGONAL STROKE]
    case '\u{A768}': // Ꝩ  [LATIN CAPITAL LETTER VEND]
    case '\u{FF36}': // Ｖ  [FULLWIDTH LATIN CAPITAL LETTER V]
      return 'V'
    case '\u{028B}': // ʋ  [LATIN SMALL LETTER V WITH HOOK]
    case '\u{028C}': // ʌ  [LATIN SMALL LETTER TURNED V]
    case '\u{1D65}': // ᵥ  [LATIN SUBSCRIPT SMALL LETTER V]
    case '\u{1D8C}': // ᶌ  [LATIN SMALL LETTER V WITH PALATAL HOOK]
    case '\u{1E7D}': // ṽ  [LATIN SMALL LETTER V WITH TILDE]
    case '\u{1E7F}': // ṿ  [LATIN SMALL LETTER V WITH DOT BELOW]
    case '\u{24E5}': // ⓥ  [CIRCLED LATIN SMALL LETTER V]
    case '\u{2C71}': // ⱱ  [LATIN SMALL LETTER V WITH RIGHT HOOK]
    case '\u{2C74}': // ⱴ  [LATIN SMALL LETTER V WITH CURL]
    case '\u{A75F}': // ꝟ  [LATIN SMALL LETTER V WITH DIAGONAL STROKE]
    case '\u{FF56}': // ｖ  [FULLWIDTH LATIN SMALL LETTER V]
      return 'v'
    case '\u{A760}': // Ꝡ  [LATIN CAPITAL LETTER VY]
      return 'VY'
    case '\u{24B1}': // ⒱  [PARENTHESIZED LATIN SMALL LETTER V]
      return '(v)'
    case '\u{A761}': // ꝡ  [LATIN SMALL LETTER VY]
      return 'vy'
    case '\u{0174}': // Ŵ  [LATIN CAPITAL LETTER W WITH CIRCUMFLEX]
    case '\u{01F7}': // Ƿ  http://en.wikipedia.org/wiki/Wynn  [LATIN CAPITAL LETTER WYNN]
    case '\u{1D21}': // ᴡ  [LATIN LETTER SMALL CAPITAL W]
    case '\u{1E80}': // Ẁ  [LATIN CAPITAL LETTER W WITH GRAVE]
    case '\u{1E82}': // Ẃ  [LATIN CAPITAL LETTER W WITH ACUTE]
    case '\u{1E84}': // Ẅ  [LATIN CAPITAL LETTER W WITH DIAERESIS]
    case '\u{1E86}': // Ẇ  [LATIN CAPITAL LETTER W WITH DOT ABOVE]
    case '\u{1E88}': // Ẉ  [LATIN CAPITAL LETTER W WITH DOT BELOW]
    case '\u{24CC}': // Ⓦ  [CIRCLED LATIN CAPITAL LETTER W]
    case '\u{2C72}': // Ⱳ  [LATIN CAPITAL LETTER W WITH HOOK]
    case '\u{FF37}': // Ｗ  [FULLWIDTH LATIN CAPITAL LETTER W]
      return 'W'
    case '\u{0175}': // ŵ  [LATIN SMALL LETTER W WITH CIRCUMFLEX]
    case '\u{01BF}': // ƿ  http://en.wikipedia.org/wiki/Wynn  [LATIN LETTER WYNN]
    case '\u{028D}': // ʍ  [LATIN SMALL LETTER TURNED W]
    case '\u{1E81}': // ẁ  [LATIN SMALL LETTER W WITH GRAVE]
    case '\u{1E83}': // ẃ  [LATIN SMALL LETTER W WITH ACUTE]
    case '\u{1E85}': // ẅ  [LATIN SMALL LETTER W WITH DIAERESIS]
    case '\u{1E87}': // ẇ  [LATIN SMALL LETTER W WITH DOT ABOVE]
    case '\u{1E89}': // ẉ  [LATIN SMALL LETTER W WITH DOT BELOW]
    case '\u{1E98}': // ẘ  [LATIN SMALL LETTER W WITH RING ABOVE]
    case '\u{24E6}': // ⓦ  [CIRCLED LATIN SMALL LETTER W]
    case '\u{2C73}': // ⱳ  [LATIN SMALL LETTER W WITH HOOK]
    case '\u{FF57}': // ｗ  [FULLWIDTH LATIN SMALL LETTER W]
      return 'w'
    case '\u{24B2}': // ⒲  [PARENTHESIZED LATIN SMALL LETTER W]
      return '(w)'
    case '\u{1E8A}': // Ẋ  [LATIN CAPITAL LETTER X WITH DOT ABOVE]
    case '\u{1E8C}': // Ẍ  [LATIN CAPITAL LETTER X WITH DIAERESIS]
    case '\u{24CD}': // Ⓧ  [CIRCLED LATIN CAPITAL LETTER X]
    case '\u{FF38}': // Ｘ  [FULLWIDTH LATIN CAPITAL LETTER X]
      return 'X'
    case '\u{1D8D}': // ᶍ  [LATIN SMALL LETTER X WITH PALATAL HOOK]
    case '\u{1E8B}': // ẋ  [LATIN SMALL LETTER X WITH DOT ABOVE]
    case '\u{1E8D}': // ẍ  [LATIN SMALL LETTER X WITH DIAERESIS]
    case '\u{2093}': // ₓ  [LATIN SUBSCRIPT SMALL LETTER X]
    case '\u{24E7}': // ⓧ  [CIRCLED LATIN SMALL LETTER X]
    case '\u{FF58}': // ｘ  [FULLWIDTH LATIN SMALL LETTER X]
      return 'x'
    case '\u{24B3}': // ⒳  [PARENTHESIZED LATIN SMALL LETTER X]
      return '(x)'
    case '\u{00DD}': // Ý  [LATIN CAPITAL LETTER Y WITH ACUTE]
    case '\u{0176}': // Ŷ  [LATIN CAPITAL LETTER Y WITH CIRCUMFLEX]
    case '\u{0178}': // Ÿ  [LATIN CAPITAL LETTER Y WITH DIAERESIS]
    case '\u{01B3}': // Ƴ  [LATIN CAPITAL LETTER Y WITH HOOK]
    case '\u{0232}': // Ȳ  [LATIN CAPITAL LETTER Y WITH MACRON]
    case '\u{024E}': // Ɏ  [LATIN CAPITAL LETTER Y WITH STROKE]
    case '\u{028F}': // ʏ  [LATIN LETTER SMALL CAPITAL Y]
    case '\u{1E8E}': // Ẏ  [LATIN CAPITAL LETTER Y WITH DOT ABOVE]
    case '\u{1EF2}': // Ỳ  [LATIN CAPITAL LETTER Y WITH GRAVE]
    case '\u{1EF4}': // Ỵ  [LATIN CAPITAL LETTER Y WITH DOT BELOW]
    case '\u{1EF6}': // Ỷ  [LATIN CAPITAL LETTER Y WITH HOOK ABOVE]
    case '\u{1EF8}': // Ỹ  [LATIN CAPITAL LETTER Y WITH TILDE]
    case '\u{1EFE}': // Ỿ  [LATIN CAPITAL LETTER Y WITH LOOP]
    case '\u{24CE}': // Ⓨ  [CIRCLED LATIN CAPITAL LETTER Y]
    case '\u{FF39}': // Ｙ  [FULLWIDTH LATIN CAPITAL LETTER Y]
      return 'Y'
    case '\u{00FD}': // ý  [LATIN SMALL LETTER Y WITH ACUTE]
    case '\u{00FF}': // ÿ  [LATIN SMALL LETTER Y WITH DIAERESIS]
    case '\u{0177}': // ŷ  [LATIN SMALL LETTER Y WITH CIRCUMFLEX]
    case '\u{01B4}': // ƴ  [LATIN SMALL LETTER Y WITH HOOK]
    case '\u{0233}': // ȳ  [LATIN SMALL LETTER Y WITH MACRON]
    case '\u{024F}': // ɏ  [LATIN SMALL LETTER Y WITH STROKE]
    case '\u{028E}': // ʎ  [LATIN SMALL LETTER TURNED Y]
    case '\u{1E8F}': // ẏ  [LATIN SMALL LETTER Y WITH DOT ABOVE]
    case '\u{1E99}': // ẙ  [LATIN SMALL LETTER Y WITH RING ABOVE]
    case '\u{1EF3}': // ỳ  [LATIN SMALL LETTER Y WITH GRAVE]
    case '\u{1EF5}': // ỵ  [LATIN SMALL LETTER Y WITH DOT BELOW]
    case '\u{1EF7}': // ỷ  [LATIN SMALL LETTER Y WITH HOOK ABOVE]
    case '\u{1EF9}': // ỹ  [LATIN SMALL LETTER Y WITH TILDE]
    case '\u{1EFF}': // ỿ  [LATIN SMALL LETTER Y WITH LOOP]
    case '\u{24E8}': // ⓨ  [CIRCLED LATIN SMALL LETTER Y]
    case '\u{FF59}': // ｙ  [FULLWIDTH LATIN SMALL LETTER Y]
      return 'y'
    case '\u{24B4}': // ⒴  [PARENTHESIZED LATIN SMALL LETTER Y]
      return '(y)'
    case '\u{0179}': // Ź  [LATIN CAPITAL LETTER Z WITH ACUTE]
    case '\u{017B}': // Ż  [LATIN CAPITAL LETTER Z WITH DOT ABOVE]
    case '\u{017D}': // Ž  [LATIN CAPITAL LETTER Z WITH CARON]
    case '\u{01B5}': // Ƶ  [LATIN CAPITAL LETTER Z WITH STROKE]
    case '\u{021C}': // Ȝ  http://en.wikipedia.org/wiki/Yogh  [LATIN CAPITAL LETTER YOGH]
    case '\u{0224}': // Ȥ  [LATIN CAPITAL LETTER Z WITH HOOK]
    case '\u{1D22}': // ᴢ  [LATIN LETTER SMALL CAPITAL Z]
    case '\u{1E90}': // Ẑ  [LATIN CAPITAL LETTER Z WITH CIRCUMFLEX]
    case '\u{1E92}': // Ẓ  [LATIN CAPITAL LETTER Z WITH DOT BELOW]
    case '\u{1E94}': // Ẕ  [LATIN CAPITAL LETTER Z WITH LINE BELOW]
    case '\u{24CF}': // Ⓩ  [CIRCLED LATIN CAPITAL LETTER Z]
    case '\u{2C6B}': // Ⱬ  [LATIN CAPITAL LETTER Z WITH DESCENDER]
    case '\u{A762}': // Ꝣ  [LATIN CAPITAL LETTER VISIGOTHIC Z]
    case '\u{FF3A}': // Ｚ  [FULLWIDTH LATIN CAPITAL LETTER Z]
      return 'Z'
    case '\u{017A}': // ź  [LATIN SMALL LETTER Z WITH ACUTE]
    case '\u{017C}': // ż  [LATIN SMALL LETTER Z WITH DOT ABOVE]
    case '\u{017E}': // ž  [LATIN SMALL LETTER Z WITH CARON]
    case '\u{01B6}': // ƶ  [LATIN SMALL LETTER Z WITH STROKE]
    case '\u{021D}': // ȝ  http://en.wikipedia.org/wiki/Yogh  [LATIN SMALL LETTER YOGH]
    case '\u{0225}': // ȥ  [LATIN SMALL LETTER Z WITH HOOK]
    case '\u{0240}': // ɀ  [LATIN SMALL LETTER Z WITH SWASH TAIL]
    case '\u{0290}': // ʐ  [LATIN SMALL LETTER Z WITH RETROFLEX HOOK]
    case '\u{0291}': // ʑ  [LATIN SMALL LETTER Z WITH CURL]
    case '\u{1D76}': // ᵶ  [LATIN SMALL LETTER Z WITH MIDDLE TILDE]
    case '\u{1D8E}': // ᶎ  [LATIN SMALL LETTER Z WITH PALATAL HOOK]
    case '\u{1E91}': // ẑ  [LATIN SMALL LETTER Z WITH CIRCUMFLEX]
    case '\u{1E93}': // ẓ  [LATIN SMALL LETTER Z WITH DOT BELOW]
    case '\u{1E95}': // ẕ  [LATIN SMALL LETTER Z WITH LINE BELOW]
    case '\u{24E9}': // ⓩ  [CIRCLED LATIN SMALL LETTER Z]
    case '\u{2C6C}': // ⱬ  [LATIN SMALL LETTER Z WITH DESCENDER]
    case '\u{A763}': // ꝣ  [LATIN SMALL LETTER VISIGOTHIC Z]
    case '\u{FF5A}': // ｚ  [FULLWIDTH LATIN SMALL LETTER Z]
      return 'z'
    case '\u{24B5}': // ⒵  [PARENTHESIZED LATIN SMALL LETTER Z]
      return '(z)'
    case '\u{2070}': // ⁰  [SUPERSCRIPT ZERO]
    case '\u{2080}': // ₀  [SUBSCRIPT ZERO]
    case '\u{24EA}': // ⓪  [CIRCLED DIGIT ZERO]
    case '\u{24FF}': // ⓿  [NEGATIVE CIRCLED DIGIT ZERO]
    case '\u{FF10}': // ０  [FULLWIDTH DIGIT ZERO]
      return '0'
    case '\u{00B9}': // ¹  [SUPERSCRIPT ONE]
    case '\u{2081}': // ₁  [SUBSCRIPT ONE]
    case '\u{2460}': // ①  [CIRCLED DIGIT ONE]
    case '\u{24F5}': // ⓵  [DOUBLE CIRCLED DIGIT ONE]
    case '\u{2776}': // ❶  [DINGBAT NEGATIVE CIRCLED DIGIT ONE]
    case '\u{2780}': // ➀  [DINGBAT CIRCLED SANS-SERIF DIGIT ONE]
    case '\u{278A}': // ➊  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT ONE]
    case '\u{FF11}': // １  [FULLWIDTH DIGIT ONE]
      return '1'
    case '\u{2488}': // ⒈  [DIGIT ONE FULL STOP]
      return '1.'
    case '\u{2474}': // ⑴  [PARENTHESIZED DIGIT ONE]
      return '(1)'
    case '\u{00B2}': // ²  [SUPERSCRIPT TWO]
    case '\u{2082}': // ₂  [SUBSCRIPT TWO]
    case '\u{2461}': // ②  [CIRCLED DIGIT TWO]
    case '\u{24F6}': // ⓶  [DOUBLE CIRCLED DIGIT TWO]
    case '\u{2777}': // ❷  [DINGBAT NEGATIVE CIRCLED DIGIT TWO]
    case '\u{2781}': // ➁  [DINGBAT CIRCLED SANS-SERIF DIGIT TWO]
    case '\u{278B}': // ➋  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT TWO]
    case '\u{FF12}': // ２  [FULLWIDTH DIGIT TWO]
      return '2'
    case '\u{2489}': // ⒉  [DIGIT TWO FULL STOP]
      return '2.'
    case '\u{2475}': // ⑵  [PARENTHESIZED DIGIT TWO]
      return '(2)'
    case '\u{00B3}': // ³  [SUPERSCRIPT THREE]
    case '\u{2083}': // ₃  [SUBSCRIPT THREE]
    case '\u{2462}': // ③  [CIRCLED DIGIT THREE]
    case '\u{24F7}': // ⓷  [DOUBLE CIRCLED DIGIT THREE]
    case '\u{2778}': // ❸  [DINGBAT NEGATIVE CIRCLED DIGIT THREE]
    case '\u{2782}': // ➂  [DINGBAT CIRCLED SANS-SERIF DIGIT THREE]
    case '\u{278C}': // ➌  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT THREE]
    case '\u{FF13}': // ３  [FULLWIDTH DIGIT THREE]
      return '3'
    case '\u{248A}': // ⒊  [DIGIT THREE FULL STOP]
      return '3.'
    case '\u{2476}': // ⑶  [PARENTHESIZED DIGIT THREE]
      return '(3)'
    case '\u{2074}': // ⁴  [SUPERSCRIPT FOUR]
    case '\u{2084}': // ₄  [SUBSCRIPT FOUR]
    case '\u{2463}': // ④  [CIRCLED DIGIT FOUR]
    case '\u{24F8}': // ⓸  [DOUBLE CIRCLED DIGIT FOUR]
    case '\u{2779}': // ❹  [DINGBAT NEGATIVE CIRCLED DIGIT FOUR]
    case '\u{2783}': // ➃  [DINGBAT CIRCLED SANS-SERIF DIGIT FOUR]
    case '\u{278D}': // ➍  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT FOUR]
    case '\u{FF14}': // ４  [FULLWIDTH DIGIT FOUR]
      return '4'
    case '\u{248B}': // ⒋  [DIGIT FOUR FULL STOP]
      return '4.'
    case '\u{2477}': // ⑷  [PARENTHESIZED DIGIT FOUR]
      return '(4)'
    case '\u{2075}': // ⁵  [SUPERSCRIPT FIVE]
    case '\u{2085}': // ₅  [SUBSCRIPT FIVE]
    case '\u{2464}': // ⑤  [CIRCLED DIGIT FIVE]
    case '\u{24F9}': // ⓹  [DOUBLE CIRCLED DIGIT FIVE]
    case '\u{277A}': // ❺  [DINGBAT NEGATIVE CIRCLED DIGIT FIVE]
    case '\u{2784}': // ➄  [DINGBAT CIRCLED SANS-SERIF DIGIT FIVE]
    case '\u{278E}': // ➎  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT FIVE]
    case '\u{FF15}': // ５  [FULLWIDTH DIGIT FIVE]
      return '5'
    case '\u{248C}': // ⒌  [DIGIT FIVE FULL STOP]
      return '5.'
    case '\u{2478}': // ⑸  [PARENTHESIZED DIGIT FIVE]
      return '(5)'
    case '\u{2076}': // ⁶  [SUPERSCRIPT SIX]
    case '\u{2086}': // ₆  [SUBSCRIPT SIX]
    case '\u{2465}': // ⑥  [CIRCLED DIGIT SIX]
    case '\u{24FA}': // ⓺  [DOUBLE CIRCLED DIGIT SIX]
    case '\u{277B}': // ❻  [DINGBAT NEGATIVE CIRCLED DIGIT SIX]
    case '\u{2785}': // ➅  [DINGBAT CIRCLED SANS-SERIF DIGIT SIX]
    case '\u{278F}': // ➏  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT SIX]
    case '\u{FF16}': // ６  [FULLWIDTH DIGIT SIX]
      return '6'
    case '\u{248D}': // ⒍  [DIGIT SIX FULL STOP]
      return '6.'
    case '\u{2479}': // ⑹  [PARENTHESIZED DIGIT SIX]
      return '(6)'
    case '\u{2077}': // ⁷  [SUPERSCRIPT SEVEN]
    case '\u{2087}': // ₇  [SUBSCRIPT SEVEN]
    case '\u{2466}': // ⑦  [CIRCLED DIGIT SEVEN]
    case '\u{24FB}': // ⓻  [DOUBLE CIRCLED DIGIT SEVEN]
    case '\u{277C}': // ❼  [DINGBAT NEGATIVE CIRCLED DIGIT SEVEN]
    case '\u{2786}': // ➆  [DINGBAT CIRCLED SANS-SERIF DIGIT SEVEN]
    case '\u{2790}': // ➐  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT SEVEN]
    case '\u{FF17}': // ７  [FULLWIDTH DIGIT SEVEN]
      return '7'
    case '\u{248E}': // ⒎  [DIGIT SEVEN FULL STOP]
      return '7.'
    case '\u{247A}': // ⑺  [PARENTHESIZED DIGIT SEVEN]
      return '(7)'
    case '\u{2078}': // ⁸  [SUPERSCRIPT EIGHT]
    case '\u{2088}': // ₈  [SUBSCRIPT EIGHT]
    case '\u{2467}': // ⑧  [CIRCLED DIGIT EIGHT]
    case '\u{24FC}': // ⓼  [DOUBLE CIRCLED DIGIT EIGHT]
    case '\u{277D}': // ❽  [DINGBAT NEGATIVE CIRCLED DIGIT EIGHT]
    case '\u{2787}': // ➇  [DINGBAT CIRCLED SANS-SERIF DIGIT EIGHT]
    case '\u{2791}': // ➑  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT EIGHT]
    case '\u{FF18}': // ８  [FULLWIDTH DIGIT EIGHT]
      return '8'
    case '\u{248F}': // ⒏  [DIGIT EIGHT FULL STOP]
      return '8.'
    case '\u{247B}': // ⑻  [PARENTHESIZED DIGIT EIGHT]
      return '(8)'
    case '\u{2079}': // ⁹  [SUPERSCRIPT NINE]
    case '\u{2089}': // ₉  [SUBSCRIPT NINE]
    case '\u{2468}': // ⑨  [CIRCLED DIGIT NINE]
    case '\u{24FD}': // ⓽  [DOUBLE CIRCLED DIGIT NINE]
    case '\u{277E}': // ❾  [DINGBAT NEGATIVE CIRCLED DIGIT NINE]
    case '\u{2788}': // ➈  [DINGBAT CIRCLED SANS-SERIF DIGIT NINE]
    case '\u{2792}': // ➒  [DINGBAT NEGATIVE CIRCLED SANS-SERIF DIGIT NINE]
    case '\u{FF19}': // ９  [FULLWIDTH DIGIT NINE]
      return '9'
    case '\u{2490}': // ⒐  [DIGIT NINE FULL STOP]
      return '9.'
    case '\u{247C}': // ⑼  [PARENTHESIZED DIGIT NINE]
      return '(9)'
    case '\u{2469}': // ⑩  [CIRCLED NUMBER TEN]
    case '\u{24FE}': // ⓾  [DOUBLE CIRCLED NUMBER TEN]
    case '\u{277F}': // ❿  [DINGBAT NEGATIVE CIRCLED NUMBER TEN]
    case '\u{2789}': // ➉  [DINGBAT CIRCLED SANS-SERIF NUMBER TEN]
    case '\u{2793}': // ➓  [DINGBAT NEGATIVE CIRCLED SANS-SERIF NUMBER TEN]
      return '10'
    case '\u{2491}': // ⒑  [NUMBER TEN FULL STOP]
      return '10.'
    case '\u{247D}': // ⑽  [PARENTHESIZED NUMBER TEN]
      return '(10)'
    case '\u{246A}': // ⑪  [CIRCLED NUMBER ELEVEN]
    case '\u{24EB}': // ⓫  [NEGATIVE CIRCLED NUMBER ELEVEN]
      return '11'
    case '\u{2492}': // ⒒  [NUMBER ELEVEN FULL STOP]
      return '11.'
    case '\u{247E}': // ⑾  [PARENTHESIZED NUMBER ELEVEN]
      return '(11)'
    case '\u{246B}': // ⑫  [CIRCLED NUMBER TWELVE]
    case '\u{24EC}': // ⓬  [NEGATIVE CIRCLED NUMBER TWELVE]
      return '12'
    case '\u{2493}': // ⒓  [NUMBER TWELVE FULL STOP]
      return '12.'
    case '\u{247F}': // ⑿  [PARENTHESIZED NUMBER TWELVE]
      return '(12)'
    case '\u{246C}': // ⑬  [CIRCLED NUMBER THIRTEEN]
    case '\u{24ED}': // ⓭  [NEGATIVE CIRCLED NUMBER THIRTEEN]
      return '13'
    case '\u{2494}': // ⒔  [NUMBER THIRTEEN FULL STOP]
      return '13.'
    case '\u{2480}': // ⒀  [PARENTHESIZED NUMBER THIRTEEN]
      return '(13)'
    case '\u{246D}': // ⑭  [CIRCLED NUMBER FOURTEEN]
    case '\u{24EE}': // ⓮  [NEGATIVE CIRCLED NUMBER FOURTEEN]
      return '14'
    case '\u{2495}': // ⒕  [NUMBER FOURTEEN FULL STOP]
      return '14.'
    case '\u{2481}': // ⒁  [PARENTHESIZED NUMBER FOURTEEN]
      return '(14)'
    case '\u{246E}': // ⑮  [CIRCLED NUMBER FIFTEEN]
    case '\u{24EF}': // ⓯  [NEGATIVE CIRCLED NUMBER FIFTEEN]
      return '15'
    case '\u{2496}': // ⒖  [NUMBER FIFTEEN FULL STOP]
      return '15.'
    case '\u{2482}': // ⒂  [PARENTHESIZED NUMBER FIFTEEN]
      return '(15)'
    case '\u{246F}': // ⑯  [CIRCLED NUMBER SIXTEEN]
    case '\u{24F0}': // ⓰  [NEGATIVE CIRCLED NUMBER SIXTEEN]
      return '16'
    case '\u{2497}': // ⒗  [NUMBER SIXTEEN FULL STOP]
      return '16.'
    case '\u{2483}': // ⒃  [PARENTHESIZED NUMBER SIXTEEN]
      return '(16)'
    case '\u{2470}': // ⑰  [CIRCLED NUMBER SEVENTEEN]
    case '\u{24F1}': // ⓱  [NEGATIVE CIRCLED NUMBER SEVENTEEN]
      return '17'
    case '\u{2498}': // ⒘  [NUMBER SEVENTEEN FULL STOP]
      return '17.'
    case '\u{2484}': // ⒄  [PARENTHESIZED NUMBER SEVENTEEN]
      return '(17)'
    case '\u{2471}': // ⑱  [CIRCLED NUMBER EIGHTEEN]
    case '\u{24F2}': // ⓲  [NEGATIVE CIRCLED NUMBER EIGHTEEN]
      return '18'
    case '\u{2499}': // ⒙  [NUMBER EIGHTEEN FULL STOP]
      return '18.'
    case '\u{2485}': // ⒅  [PARENTHESIZED NUMBER EIGHTEEN]
      return '(18)'
    case '\u{2472}': // ⑲  [CIRCLED NUMBER NINETEEN]
    case '\u{24F3}': // ⓳  [NEGATIVE CIRCLED NUMBER NINETEEN]
      return '19'
    case '\u{249A}': // ⒚  [NUMBER NINETEEN FULL STOP]
      return '19.'
    case '\u{2486}': // ⒆  [PARENTHESIZED NUMBER NINETEEN]
      return '(19)'
    case '\u{2473}': // ⑳  [CIRCLED NUMBER TWENTY]
    case '\u{24F4}': // ⓴  [NEGATIVE CIRCLED NUMBER TWENTY]
      return '20'
    case '\u{249B}': // ⒛  [NUMBER TWENTY FULL STOP]
      return '20.'
    case '\u{2487}': // ⒇  [PARENTHESIZED NUMBER TWENTY]
      return '(20)'
    case '\u{00AB}': // «  [LEFT-POINTING DOUBLE ANGLE QUOTATION MARK]
    case '\u{00BB}': // »  [RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK]
    case '\u{201C}': // “  [LEFT DOUBLE QUOTATION MARK]
    case '\u{201D}': // ”  [RIGHT DOUBLE QUOTATION MARK]
    case '\u{201E}': // „  [DOUBLE LOW-9 QUOTATION MARK]
    case '\u{2033}': // ″  [DOUBLE PRIME]
    case '\u{2036}': // ‶  [REVERSED DOUBLE PRIME]
    case '\u{275D}': // ❝  [HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT]
    case '\u{275E}': // ❞  [HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT]
    case '\u{276E}': // ❮  [HEAVY LEFT-POINTING ANGLE QUOTATION MARK ORNAMENT]
    case '\u{276F}': // ❯  [HEAVY RIGHT-POINTING ANGLE QUOTATION MARK ORNAMENT]
    case '\u{FF02}': // ＂  [FULLWIDTH QUOTATION MARK]
      return '"'
    case '\u{2018}': // ‘  [LEFT SINGLE QUOTATION MARK]
    case '\u{2019}': // ’  [RIGHT SINGLE QUOTATION MARK]
    case '\u{201A}': // ‚  [SINGLE LOW-9 QUOTATION MARK]
    case '\u{201B}': // ‛  [SINGLE HIGH-REVERSED-9 QUOTATION MARK]
    case '\u{2032}': // ′  [PRIME]
    case '\u{2035}': // ‵  [REVERSED PRIME]
    case '\u{2039}': // ‹  [SINGLE LEFT-POINTING ANGLE QUOTATION MARK]
    case '\u{203A}': // ›  [SINGLE RIGHT-POINTING ANGLE QUOTATION MARK]
    case '\u{275B}': // ❛  [HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT]
    case '\u{275C}': // ❜  [HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT]
    case '\u{FF07}': // ＇  [FULLWIDTH APOSTROPHE]
      return '\''
    case '\u{2010}': // ‐  [HYPHEN]
    case '\u{2011}': // ‑  [NON-BREAKING HYPHEN]
    case '\u{2012}': // ‒  [FIGURE DASH]
    case '\u{2013}': // –  [EN DASH]
    case '\u{2014}': // —  [EM DASH]
    case '\u{207B}': // ⁻  [SUPERSCRIPT MINUS]
    case '\u{208B}': // ₋  [SUBSCRIPT MINUS]
    case '\u{FF0D}': // －  [FULLWIDTH HYPHEN-MINUS]
      return '-'
    case '\u{2045}': // ⁅  [LEFT SQUARE BRACKET WITH QUILL]
    case '\u{2772}': // ❲  [LIGHT LEFT TORTOISE SHELL BRACKET ORNAMENT]
    case '\u{FF3B}': // ［  [FULLWIDTH LEFT SQUARE BRACKET]
      return '['
    case '\u{2046}': // ⁆  [RIGHT SQUARE BRACKET WITH QUILL]
    case '\u{2773}': // ❳  [LIGHT RIGHT TORTOISE SHELL BRACKET ORNAMENT]
    case '\u{FF3D}': // ］  [FULLWIDTH RIGHT SQUARE BRACKET]
      return ']'
    case '\u{207D}': // ⁽  [SUPERSCRIPT LEFT PARENTHESIS]
    case '\u{208D}': // ₍  [SUBSCRIPT LEFT PARENTHESIS]
    case '\u{2768}': // ❨  [MEDIUM LEFT PARENTHESIS ORNAMENT]
    case '\u{276A}': // ❪  [MEDIUM FLATTENED LEFT PARENTHESIS ORNAMENT]
    case '\u{FF08}': // （  [FULLWIDTH LEFT PARENTHESIS]
      return '('
    case '\u{2E28}': // ⸨  [LEFT DOUBLE PARENTHESIS]
      return '(('
    case '\u{207E}': // ⁾  [SUPERSCRIPT RIGHT PARENTHESIS]
    case '\u{208E}': // ₎  [SUBSCRIPT RIGHT PARENTHESIS]
    case '\u{2769}': // ❩  [MEDIUM RIGHT PARENTHESIS ORNAMENT]
    case '\u{276B}': // ❫  [MEDIUM FLATTENED RIGHT PARENTHESIS ORNAMENT]
    case '\u{FF09}': // ）  [FULLWIDTH RIGHT PARENTHESIS]
      return ')'
    case '\u{2E29}': // ⸩  [RIGHT DOUBLE PARENTHESIS]
      return '))'
    case '\u{276C}': // ❬  [MEDIUM LEFT-POINTING ANGLE BRACKET ORNAMENT]
    case '\u{2770}': // ❰  [HEAVY LEFT-POINTING ANGLE BRACKET ORNAMENT]
    case '\u{FF1C}': // ＜  [FULLWIDTH LESS-THAN SIGN]
      return '<'
    case '\u{276D}': // ❭  [MEDIUM RIGHT-POINTING ANGLE BRACKET ORNAMENT]
    case '\u{2771}': // ❱  [HEAVY RIGHT-POINTING ANGLE BRACKET ORNAMENT]
    case '\u{FF1E}': // ＞  [FULLWIDTH GREATER-THAN SIGN]
      return '>'
    case '\u{2774}': // ❴  [MEDIUM LEFT CURLY BRACKET ORNAMENT]
    case '\u{FF5B}': // ｛  [FULLWIDTH LEFT CURLY BRACKET]
      return '{'
    case '\u{2775}': // ❵  [MEDIUM RIGHT CURLY BRACKET ORNAMENT]
    case '\u{FF5D}': // ｝  [FULLWIDTH RIGHT CURLY BRACKET]
      return '}'
    case '\u{207A}': // ⁺  [SUPERSCRIPT PLUS SIGN]
    case '\u{208A}': // ₊  [SUBSCRIPT PLUS SIGN]
    case '\u{FF0B}': // ＋  [FULLWIDTH PLUS SIGN]
      return '+'
    case '\u{207C}': // ⁼  [SUPERSCRIPT EQUALS SIGN]
    case '\u{208C}': // ₌  [SUBSCRIPT EQUALS SIGN]
    case '\u{FF1D}': // ＝  [FULLWIDTH EQUALS SIGN]
      return '='
    case '\u{FF01}': // ！  [FULLWIDTH EXCLAMATION MARK]
      return '!'
    case '\u{203C}': // ‼  [DOUBLE EXCLAMATION MARK]
      return '!!'
    case '\u{2049}': // ⁉  [EXCLAMATION QUESTION MARK]
      return '!?'
    case '\u{FF03}': // ＃  [FULLWIDTH NUMBER SIGN]
      return '#'
    case '\u{FF04}': // ＄  [FULLWIDTH DOLLAR SIGN]
      return '$'
    case '\u{2052}': // ⁒  [COMMERCIAL MINUS SIGN]
    case '\u{FF05}': // ％  [FULLWIDTH PERCENT SIGN]
      return '%'
    case '\u{FF06}': // ＆  [FULLWIDTH AMPERSAND]
      return '&'
    case '\u{204E}': // ⁎  [LOW ASTERISK]
    case '\u{FF0A}': // ＊  [FULLWIDTH ASTERISK]
      return '*'
    case '\u{FF0C}': // ，  [FULLWIDTH COMMA]
      return ','
    case '\u{FF0E}': // ．  [FULLWIDTH FULL STOP]
      return '.'
    case '\u{2044}': // ⁄  [FRACTION SLASH]
    case '\u{FF0F}': // ／  [FULLWIDTH SOLIDUS]
      return '/'
    case '\u{FF1A}': // ：  [FULLWIDTH COLON]
      return ':'
    case '\u{204F}': // ⁏  [REVERSED SEMICOLON]
    case '\u{FF1B}': // ；  [FULLWIDTH SEMICOLON]
      return ';'
    case '\u{FF1F}': // ？  [FULLWIDTH QUESTION MARK]
      return '?'
    case '\u{2047}': // ⁇  [DOUBLE QUESTION MARK]
      return '??'
    case '\u{2048}': // ⁈  [QUESTION EXCLAMATION MARK]
      return '?!'
    case '\u{FF20}': // ＠  [FULLWIDTH COMMERCIAL AT]
      return '@'
    case '\u{FF3C}': // ＼  [FULLWIDTH REVERSE SOLIDUS]
      return '\\'
    case '\u{2038}': // ‸  [CARET]
    case '\u{FF3E}': // ＾  [FULLWIDTH CIRCUMFLEX ACCENT]
      return '^'
    case '\u{FF3F}': // ＿  [FULLWIDTH LOW LINE]
      return '_'
    case '\u{2053}': // ⁓  [SWUNG DASH]
    case '\u{FF5E}': // ～  [FULLWIDTH TILDE]
      return '~'

    default:
      return char
  }
}

export default (str) => str.replace(/[^A-Za-z0-9]/g, replaceChar)
